(() => {
  'use strict';
  let customerLive;
  let proposalExpiryTimer;

  const root = document.querySelector('[data-florame-messages-app]');
  if (!root || root.__florameMessagesMounted) return;
  root.__florameMessagesMounted = true;
  const demoMode = new URL(location.href).searchParams.get('demo') === '1';
  const demo = demoMode ? window.FlorameReviewDemo : null;
  if (demoMode && !demo) { root.textContent = 'Demo non disponibile / Demo unavailable. Reload this page.'; return; }
  if (demo) demo.mount(root);

  function getLocale() {
    const language = window.FlorameI18n?.getLanguage?.() || document.documentElement.lang || 'it';
    return String(language).startsWith('en') ? 'en-GB' : 'it-IT';
  }

  const apiPath = root.dataset.apiPath || '/apps/florame-messages';
  const initialPartner = String(root.dataset.partnerSlug || new URL(location.href).searchParams.get('partner') || '').trim();
  const initialOrderId = String(new URL(location.href).searchParams.get('orderId') || '').trim();
  const initialCompose = String(new URL(location.href).searchParams.get('compose') || '').trim();
  const initialAuthenticated = demoMode || root.dataset.authenticated === 'true';
  const state = {
    threads: [],
    listCursor: "", messagesCursor: "", listExpanded: false, historyExpanded: false, pageBusy: false, openSequence: 0,
    selected: null,
    messages: [],
    preferences: {},
    search: '',
    busy: false,
    outbox: [], sendingThreads: new Set(), verifyingMessages: new Set(), proposalBusy: false, authExpired: false,
    newMessages: 0, inboxLoading: false, sessionEpoch: 0,
    drafts: new Map(),
    threadLoading: false,
    threadReady: false,
    filter: 'all',
    composePrepared: false,
    poll: null
  };

  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => [...scope.querySelectorAll(selector)];
  const list = $('[data-messages-list]');
  const status = $('[data-messages-status]');
  const thread = $('[data-messages-thread]');
  const blank = $('[data-messages-blank]');
  const messagesNode = $('[data-messages-messages]');
  const scrollNode = $('[data-messages-thread-scroll]');
  const composer = $('[data-messages-composer]');
  const readonly = $('[data-messages-readonly]');
  const draft = $('[data-messages-draft]');
  const send = $('[data-messages-send]');
  const settings = $('[data-messages-settings]');
  const detailsSheet = $('[data-messages-details-sheet]');
  const orderSheet = $('[data-messages-order-sheet]');
  const photoSheet = $('[data-messages-photo-sheet]');
  const latest = $('[data-messages-latest]');
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Private tab-local state. No conversation body is placed in the public read cache.
  const sessionKey = demoMode ? 'florame_review_demo_messages_v1' : root.dataset.customerId ? 'florame_messages_session_v1:' + root.dataset.customerId : '';
  const confirmations = new Set(), observedConfirmations = new Map();
  const conversationMemory = new Map();
  function saveSession() {
    if (!sessionKey || state.authExpired) return;
    try { sessionStorage.setItem(sessionKey, JSON.stringify({ at: Date.now(), drafts: [...state.drafts], outbox: state.outbox, confirmations: [...confirmations] })); } catch (_) {}
  }
  try {
    // Purge records belonging to a previous login in this tab.
    if (!demoMode) for (const key of Object.keys(sessionStorage)) if (key.startsWith('florame_messages_session_v1:') && key !== sessionKey) sessionStorage.removeItem(key);
    const saved = sessionKey && JSON.parse(sessionStorage.getItem(sessionKey) || 'null');
    if (saved && Date.now() >= saved.at && Date.now() - saved.at < 86400000) {
      state.drafts = new Map(Array.isArray(saved.drafts) ? saved.drafts : []);
      state.outbox = (Array.isArray(saved.outbox) ? saved.outbox : []).filter(row => row && typeof row.text === 'string' && row.text.length <= 1200 && row.threadId && row.key).map(row => ({ ...row, status: row.status === 'sent' ? 'sent' : 'uncertain' }));
      (saved.confirmations || []).forEach(key => confirmations.add(key));
    }
  } catch (_) {}
  function reconcileOutbox(rows) {
    const ids = new Set(rows.map(row => row.messageId)), keys = new Set(rows.filter(row => row.sender === 'customer').map(row => row.clientRequestId).filter(Boolean));
    state.outbox = state.outbox.filter(row => !keys.has(row.key) && !(row.serverId && ids.has(row.serverId)));
    saveSession();
  }
  function outboxMessages() {
    return state.outbox.filter(row => row.threadId === state.selected?.threadId).map(row => ({
      messageId: row.serverId || 'local-' + row.key, clientRequestId: row.key, sender: 'customer', kind: 'text', text: row.text,
      createdAt: row.createdAt, localStatus: row.status, verifying: state.verifyingMessages.has(row.key), retryAt: row.retryAt || 0, localError: row.error || ''
    }));
  }
  function refreshLocalThread(id) { if (state.selected?.threadId === id && state.threadReady) renderMessages({ keepScroll: scrollNode.scrollHeight - scrollNode.scrollTop - scrollNode.clientHeight > 100 }); }
  function clearPrivateState() {
    customerLive?.close();
    state.authExpired = true; state.sessionEpoch++; state.openSequence++;
    state.drafts.clear(); state.outbox = []; conversationMemory.clear(); confirmations.clear();
    try { if (sessionKey) sessionStorage.removeItem(sessionKey); } catch (_) {}
    state.selected = null; state.messages = []; state.threads = []; state.threadReady = false;
    draft.value = ''; messagesNode.replaceChildren(); $('[data-messages-context]').replaceChildren(); list.replaceChildren();
    utilitySheets.forEach(layer => { if (!layer.hidden) closeUtility(layer); });
    const account = document.querySelector('[data-florame-account-center]')?.__florameAccountCenter;
    if (account?.helpContext || (account?.lastTrigger && root.contains(account.lastTrigger))) { account.clearHelpContext(); account.close(false); }
    closePhoto(); closeOrderDetails({restoreUrl:false}); closePartnerDetails(); closeSettings(); thread.hidden = true; root.classList.remove('is-thread-open');
    updateComposer(); loginState();
  }
  ['florame:logout', 'florame:auth-changed'].forEach(name => document.addEventListener(name, clearPrivateState));
  window.addEventListener('pagehide', saveSession);

  async function drainOutbox(id) {
    if (state.sendingThreads.has(id) || state.authExpired || !navigator.onLine) return;
    state.sendingThreads.add(id);
    const epoch = state.sessionEpoch;
    try {
      while (epoch === state.sessionEpoch) {
        const row = state.outbox.find(item => item.threadId === id && item.status !== 'sent');
        if (!row || row.status !== 'queued') break;
        row.status = 'sending'; saveSession(); refreshLocalThread(id);
        try {
          const result = await request('send', { method: 'POST', body: { threadId: id, text: row.text, idempotencyKey: row.key } });
          if (epoch !== state.sessionEpoch) return;
          row.serverId = result.message?.messageId || ''; row.status = row.serverId ? 'sent' : 'uncertain';
          row.error = ''; saveSession(); refreshLocalThread(id);
        } catch (error) {
          if (epoch !== state.sessionEpoch) return;
          row.status = [400,403,404,409,429].includes(error.status) ? 'failed' : 'uncertain';
          row.retryAt = error.status === 429 ? Date.now() + Math.max(1000, error.retryAfterMs || 30000) : 0;
          row.error = error.status === 401 ? 'Accedi di nuovo per verificare l’invio.'
            : error.status === 403 ? 'Questa conversazione non accetta risposte.'
            : error.status === 409 ? 'La conversazione è cambiata. Verifica con Florame.'
            : error.status === 429 ? 'Troppi invii ravvicinati. Attendi qualche secondo.'
            : error.status === 404 ? 'La conversazione non è più disponibile.' : '';
          saveSession(); refreshLocalThread(id);
          if (error.status === 401) { clearPrivateState(); requestAuthentication(send, 'messages_send'); }
          break;
        }
      }
    } finally {
      state.sendingThreads.delete(id);
      if (epoch === state.sessionEpoch && state.selected?.threadId === id && !state.threadLoading) void openThread(state.selected, { quiet: true });
    }
  }
  async function retryMessage(key) {
    const row = state.outbox.find(item => item.key === key);
    if (!row || state.authExpired || state.sendingThreads.has(row.threadId) || state.verifyingMessages.has(key)) return;
    if (!navigator.onLine) { setMessageStatus('Sei offline. Torna online per verificare questo invio.'); return; }
    if (row.retryAt > Date.now()) { setMessageStatus('Puoi riprovare tra ' + Math.ceil((row.retryAt - Date.now()) / 1000) + ' secondi.'); return; }
    const epoch = state.sessionEpoch;
    state.verifyingMessages.add(key); refreshLocalThread(row.threadId);
    try {
      // A lost response may hide a successful write. Reconcile before resending the same key.
      try {
        const payload = await request('thread', { query: { threadId: row.threadId } });
        if (epoch !== state.sessionEpoch) return;
        reconcileOutbox(payload.messages || []);
      } catch (error) {
        if (epoch !== state.sessionEpoch) return;
        if (error.status === 401) { clearPrivateState(); requestAuthentication(send, 'messages_send'); return; }
      }
      if (epoch !== state.sessionEpoch) return;
      if (!state.outbox.includes(row)) { if(state.selected?.threadId === row.threadId) void openThread(state.selected, {quiet:true}); return; }
      row.status = 'queued'; row.error = ''; saveSession(); refreshLocalThread(row.threadId); void drainOutbox(row.threadId);
    } finally {
      state.verifyingMessages.delete(key);
      if (epoch === state.sessionEpoch) refreshLocalThread(row.threadId);
    }
  }

  function updateComposer() {
    const unavailable = state.authExpired || !state.threadReady || state.selected?.readOnly || state.selected?.conversationKind === 'florame';
    send.disabled = !draft.value.trim() || state.busy || unavailable;
    send.setAttribute('aria-busy', String(state.busy));
    send.setAttribute('aria-label', state.busy ? 'Invio del messaggio…' : 'Invia messaggio');
    draft.disabled = !!unavailable;
    resizeComposer();
  }

  function resizeComposer() {
    if (!draft.getClientRects().length) return;
    const style = getComputedStyle(draft);
    const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    const previousScroll = draft.scrollTop;
    draft.style.overflowY = 'hidden';
    draft.style.height = 'auto';
    const height = draft.scrollHeight + border;
    draft.style.height = `${Math.min(120, Math.max(48, height))}px`;
    draft.style.overflowY = height > 120 ? 'auto' : 'hidden';
    if (height > 120) draft.scrollTop = previousScroll;
  }

  function updateLatest() {
    const nearBottom = scrollNode.scrollHeight - scrollNode.scrollTop - scrollNode.clientHeight < 100;
    if (nearBottom) state.newMessages = 0;
    if (latest) {
      latest.hidden = !state.threadReady || nearBottom;
      latest.lastChild.textContent = state.newMessages ? (state.newMessages + (state.newMessages === 1 ? ' nuovo messaggio' : ' nuovi messaggi')) : 'Ultimi messaggi';
    }
  }

  function jumpToLatest() {
    scrollNode.scrollTo({ top: scrollNode.scrollHeight, behavior: reducedMotion() ? 'instant' : 'smooth' });
  }

  function renderPhoto(url, title, size = 92) {
    const image = safeImage(url);
    if (!image) return '';
    const img = `<img src="${escapeHtml(image)}" alt="${escapeHtml(title || 'Bouquet Florame')}" width="${size}" height="${size}" loading="lazy">`;
    return `<button type="button" class="florame-messages__photo" style="--photo-size:${size}px" data-messages-photo="${escapeHtml(image)}" data-photo-title="${escapeHtml(title || 'Bouquet Florame')}" aria-label="${escapeHtml(`Ingrandisci la foto: ${title || 'Bouquet Florame'}`)}" aria-haspopup="dialog">${window.FlorameImageVariants?.html(img, `${size}px`) || img}</button>`;
  }

  function openPhoto(button) {
    const url = safeImage(button.dataset.messagesPhoto);
    if (!photoSheet || !url) return;
    // Safari pointer clicks may leave focus on the preceding summary.
    rememberSheetOpener(photoSheet, button);
    const image = $('[data-messages-photo-image]');
    image.hidden = false;
    $('[data-messages-photo-error]').hidden = true;
    image.alt = button.dataset.photoTitle || 'Bouquet Florame';
    image.src = url;
    $('[data-messages-photo-title]').textContent = image.alt;
    photoSheet.hidden = false;
    document.body.classList.add('florame-messages-overlay-open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => $('.florame-messages__sheet-panel', photoSheet)?.focus());
  }

  function closePhoto() {
    if (!photoSheet) return;
    photoSheet.hidden = true;
    restoreSheetOpener(photoSheet);
    if ([orderSheet, detailsSheet, settings].every(sheet => !sheet || sheet.hidden)) {
      document.body.classList.remove('florame-messages-overlay-open');
      document.documentElement.style.removeProperty('overflow');
    }
  }

  function setMessageStatus(message) {
    status.textContent = message;
    const threadStatus = $('[data-messages-thread-status]');
    if (threadStatus) threadStatus.textContent = message;
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
  }

  function safeImage(value) {
    if (!String(value || '').trim()) return '';
    try {
      const url = new URL(String(value || ''), location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }

  function safeUrl(value) {
    if (!String(value || '').trim()) return '';
    try {
      const url = new URL(String(value || ''), location.origin);
      return /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }

  function initials(name) {
    return String(name || 'F').split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
  }

  function avatar(threadData, compact = false) {
    const isFlorame = threadData?.conversationKind === 'florame';
    const image = safeImage(threadData?.partnerAvatarUrl);
    const className = `${compact ? 'florame-messages__thread-avatar' : 'florame-messages__avatar'}${isFlorame ? ' florame-messages__avatar--florame' : ''}`;
    if (image) return `<span class="${className}">${window.FlorameImageVariants?.html(`<img src="${escapeHtml(image)}" alt="" width="64" height="64" loading="lazy">`, "64px") || `<img src="${escapeHtml(image)}" alt="" width="64" height="64" loading="lazy">`}</span>`;
    return `<span class="${className}" aria-hidden="true">${escapeHtml(initials(threadData?.partnerName))}</span>`;
  }

  function relativeTime(value) {
    const time = Date.parse(value || '');
    if (!Number.isFinite(time)) return '';
    const minutes = Math.max(0, Math.floor((Date.now() - time) / 60000));
    if (minutes < 2) return 'Ora';
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} h`;
    const date = new Date(time);
    if (hours < 48) return 'Ieri';
    return date.toLocaleDateString(getLocale(), { day: '2-digit', month: '2-digit', year: date.getFullYear() === new Date().getFullYear() ? undefined : '2-digit' });
  }

  function formatPrice(cents, currency = 'EUR') {
    return new Intl.NumberFormat(getLocale(), { style: 'currency', currency: currency || 'EUR' })
      .format(Math.max(0, Number(cents || 0)) / 100);
  }

  function materialLabel(value) {
    const colors = {lightpink:'rosa chiaro',white:'bianco',pink:'rosa',red:'rosso',yellow:'giallo',orange:'arancione',green:'verde',blue:'blu',skyblue:'azzurro',purple:'viola',fuchsia:'fucsia'};
    return String(value || '').replace(/\b(lightpink|white|pink|red|yellow|orange|green|blue|skyblue|purple|fuchsia)\b/gi, color => colors[color.toLowerCase()]);
  }

  function renderProposalCard(proposal = {}) {
    const image = safeImage(proposal.imageUrl);
    const expired = proposal.expiresAt && Date.parse(proposal.expiresAt) <= Date.now() && ['available','sent','viewed','checkout_started','payment_failed'].includes(proposal.status);
    const status = expired ? 'expired' : proposal.status || 'sent';
    const actionable = ['available', 'sent', 'viewed', 'checkout_started', 'payment_failed'].includes(status);
    const composition = (Array.isArray(proposal.composition) ? proposal.composition : [])
      .filter((item) => item?.label)
      .map((item) => `${Math.max(1, Number(item.quantity || 1))}× ${item.label}${item.color && !item.label.toLowerCase().includes(String(item.color).toLowerCase()) ? ` · ${item.color}` : ''}`)
      .slice(0, 30);
    const packaging = [proposal.packaging?.paper, proposal.packaging?.ribbon, ...(proposal.packaging?.decorations || [])].filter(Boolean);
    const flowerCount = (proposal.composition || []).reduce((sum, item) => sum + Math.max(1, Number(item.quantity || 1)), 0);
    const statusCopy = {
      accepted: 'Proposta confermata',
      declined: 'Proposta non accettata',
      expired: 'Proposta scaduta',
      payment_processing: 'Pagamento in verifica',
      payment_failed: 'Puoi riprovare il checkout',
      checkout_started: 'Riepilogo pronto da rivedere',
      superseded: 'Sostituita da una nuova proposta',
      unavailable: 'Proposta non disponibile'
    }[status] || 'Nuova proposta del fiorista';
    return `<article class="florame-messages__proposal" data-proposal-state="${escapeHtml(status)}" data-proposal-id="${escapeHtml(proposal.proposalId || '')}">
      <div class="florame-messages__proposal-head">
        ${image ? renderPhoto(image, proposal.title) : '<span class="florame-messages__proposal-placeholder" aria-label="Foto non disponibile">✿</span>'}
        <span class="florame-messages__proposal-copy"><small>${escapeHtml(statusCopy)}</small><strong>${escapeHtml(proposal.title || 'Bouquet su misura')}</strong><b>${escapeHtml(formatPrice(proposal.priceCents, proposal.currency))}</b><small>Prezzo del bouquet</small></span>
      </div>
      ${actionable && proposal.expiresAt && Number.isFinite(Date.parse(proposal.expiresAt)) ? `<p class="florame-messages__proposal-expiry">Disponibile fino al ${escapeHtml(new Date(proposal.expiresAt).toLocaleString(getLocale(), {day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}))}</p>` : ''}
      ${composition.length ? `<details class="florame-messages__proposal-detail"><summary>Composizione · ${flowerCount} steli</summary><p>${composition.map(escapeHtml).join(' · ')}</p></details>` : ''}
      ${packaging.length ? `<details class="florame-messages__proposal-detail"><summary>Carta, nastro e decorazioni</summary><p>${packaging.map(escapeHtml).join(' · ')}</p></details>` : ''}
      ${proposal.description || proposal.shortDescription ? `<details class="florame-messages__proposal-detail"><summary>Il bouquet in dettaglio</summary><p>${escapeHtml(proposal.description || proposal.shortDescription)}</p></details>` : ''}
      ${proposal.financial?.originalAuthorizationReleased ? `<p class="florame-messages__proposal-safe">${escapeHtml(proposalPaymentCopy())} Rivedi consegna e totale prima di continuare.</p>` : ''}
      ${actionable && proposal.proposalId ? `<div class="florame-messages__proposal-actions"><button type="button" data-proposal-action="decline">Non accetto</button><button type="button" data-proposal-action="checkout">Rivedi e continua</button></div>` : ''}
      ${status === 'accepted' && /^\d+$/.test(String(proposal.replacementOrderId || '')) ? `<a class="florame-messages__event-action is-primary" href="/pages/florame-order?orderId=${encodeURIComponent(proposal.replacementOrderId)}">Apri il nuovo ordine</a>` : ''}
      ${['declined','expired','superseded','unavailable','payment_failed'].includes(status) ? '<button type="button" class="florame-messages__proposal-support" data-proposal-support>Troviamo una soluzione · Assistenza</button>' : ''}
      ${status === 'accepted' && proposal.coupon?.code && Number(proposal.coupon.percentage) > 0 && (!proposal.coupon.expiresAt || Date.parse(proposal.coupon.expiresAt) > Date.now()) ? `<details class="florame-messages__proposal-coupon"><summary>Il tuo vantaggio · ${escapeHtml(proposal.coupon.percentage)}%</summary><p>Codice <strong>${escapeHtml(proposal.coupon.code)}</strong>${proposal.coupon.expiresAt ? ` · Valido fino al ${escapeHtml(new Date(proposal.coupon.expiresAt).toLocaleDateString(getLocale()))}` : ''}</p></details>` : ''}
    </article>`;
  }

  function proposalPaymentCopy() {
    const status = state.selected?.orderDetail?.payment?.status;
    if (status === 'refunded') return 'Il rimborso del pagamento iniziale è stato disposto sul metodo originale. I tempi di accredito dipendono dal gestore del pagamento.';
    if (status === 'voided') return 'Il pagamento iniziale è stato annullato. I tempi di sblocco dell’importo dipendono dal gestore del pagamento.';
    if (status === 'partially_refunded') return 'Il pagamento iniziale risulta rimborsato in parte. Consulta gli importi nei dettagli dell’ordine.';
    return 'Abbiamo avviato l’annullamento del pagamento iniziale. L’importo viene sbloccato o rimborsato, secondo il metodo usato.';
  }

  function proposalSlotKey(value) {
    const time = String(value || '').toLowerCase();
    if (time.includes('matt') || time.includes('09') || time.includes('12')) return 'morning';
    if (time.includes('pomer') || time.includes('14') || time.includes('17')) return 'afternoon';
    if (time.includes('sera') || time.includes('18') || time.includes('21')) return 'evening';
    return time;
  }

  async function checkoutProposal(button, proposalId) {
    if (demoMode) return demo.note();
    if(state.proposalBusy || state.authExpired || !proposalId) return;
    state.proposalBusy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Preparo il riepilogo…';
    setMessageStatus('');
    const epoch = state.sessionEpoch;
    let originalCart = null;
    let cartMutationStarted = false;
    let proposalAttributes = {};
    const cartRequest = async (path, body) => {
      if (epoch !== state.sessionEpoch) throw new Error('SESSION_CHANGED');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
      const response = await fetch(path, {
        method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store',
        signal: controller.signal,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        ...(body === undefined ? {} : { body: JSON.stringify(body) })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result?.description || 'PROPOSAL_CART_UPDATE_FAILED');
      return result;
      } finally { clearTimeout(timeout); }
    };
    try {
      setMessageStatus('Verifico la proposta…');
      const payload = await request('proposal_checkout', { method: 'POST', body: { proposalId } });
      const checkout = payload.checkout || {};
      if (!/^\d+$/.test(String(checkout.variantId || ''))) throw new Error('PROPOSAL_VARIANT_UNAVAILABLE');
      const currentCart = await cartRequest('/cart.js');
      if (!Array.isArray(currentCart.items)) throw new Error('PROPOSAL_CART_UNAVAILABLE');
      if (Number(currentCart.item_count || 0) > 0 && !await confirmChoice('Per continuare con la proposta sostituiremo i prodotti nel carrello attuale. Potrai rivedere consegna e totale prima del pagamento.', 'Usa questa proposta')) { setMessageStatus(''); return; }
      if (epoch !== state.sessionEpoch) return;
      originalCart = currentCart;
      proposalAttributes = checkout.cartAttributes || {};
      setMessageStatus('Preparo il tuo carrello…');
      cartMutationStarted = true;
      await cartRequest('/cart/clear.js', {});
      await cartRequest('/cart/add.js', { id: Number(checkout.variantId), quantity: Number(checkout.quantity || 1), properties: checkout.lineProperties || {} });
      await cartRequest('/cart/update.js', {
        attributes: { ...Object.fromEntries(Object.keys(currentCart.attributes || {}).map(key => [key, ''])), ...checkout.cartAttributes }
      });
      if (epoch !== state.sessionEpoch) return;
      const resume = checkout.deliveryResume || {};
      const deliveryAttributes = checkout.cartAttributes || {};
      const intent = {
        version: 1,
        deliveryType: resume.method || 'delivery',
        selectedDate: /^\d{4}-\d{2}-\d{2}$/.test(String(resume.date || '')) ? resume.date : '',
        selectedTimeSlot: proposalSlotKey(resume.time),
        address: resume.address ? { display: resume.address, fullAddress: resume.address } : {},
        deliveryDetails: {
          apartment: deliveryAttributes.Interno || '',
          staircase: deliveryAttributes.Scala || '',
          floor: deliveryAttributes.Piano || '',
          intercom: deliveryAttributes.Citofono || deliveryAttributes.Campanello || '',
          notes: deliveryAttributes['Note indirizzo'] || ''
        },
        source: 'counter_proposal',
        proposalId,
        savedAt: Date.now()
      };
      [window.sessionStorage, window.localStorage].forEach((storage) => {
        try { storage.setItem('florame_delivery_intent_v1', JSON.stringify(intent)); } catch (_) {}
      });
      try { sessionStorage.setItem('florame_counter_proposal_resume_v1', JSON.stringify({ proposalId, checkout, intent, savedAt: Date.now() })); } catch (_) {}
      location.href = `/cart?proposal=${encodeURIComponent(proposalId)}&review=delivery`;
    } catch (error) {
      if (epoch !== state.sessionEpoch) return;
      let restored = false;
      if (cartMutationStarted && originalCart) {
        try {
          await cartRequest('/cart/clear.js', {});
          const items = originalCart.items.map(item => ({
            id: item.variant_id || item.id, quantity: item.quantity, properties: item.properties || {},
            ...(item.selling_plan_allocation?.selling_plan?.id ? { selling_plan: item.selling_plan_allocation.selling_plan.id } : {})
          }));
          if (items.length) await cartRequest('/cart/add.js', { items });
          await cartRequest('/cart/update.js', {
            attributes: { ...Object.fromEntries(Object.keys(proposalAttributes).map(key => [key, ''])), ...originalCart.attributes },
            note: originalCart.note || ''
          });
          restored = true;
        } catch (_) { /* Keep the customer here if cart recovery also fails. */ }
      }
      setMessageStatus(error?.message === 'proposal_expired' ? 'Questa proposta è scaduta.'
        : error?.message === 'proposal_product_changed' ? 'Il bouquet della proposta è cambiato. Scrivi qui per ricevere una proposta aggiornata.'
        : restored ? 'Non siamo riusciti a preparare la proposta. Il carrello precedente è stato ripristinato: puoi riprovare.'
          : cartMutationStarted ? 'Non siamo riusciti a completare il cambio. Apri il carrello e controlla i prodotti prima di riprovare.'
            : 'Non riusciamo ad aprire il riepilogo. Riprova tra poco.');
      if (cartMutationStarted && !restored) {
        const actions = document.createElement('span'); actions.className = 'florame-messages__recovery';
        actions.innerHTML = '<a href="/cart">Controlla il carrello</a><button type="button" data-proposal-support>Chiedi assistenza</button>';
        $('[data-messages-thread-status]').append(actions);
      }
    } finally {
      state.proposalBusy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'Rivedi e continua';
    }
  }

  async function declineProposal(button, proposalId) {
    if(state.proposalBusy || state.authExpired || !proposalId) return;
    const epoch = state.sessionEpoch, threadId = state.selected?.threadId;
    state.proposalBusy = true;
    if (!await confirmChoice('Vuoi rifiutare questa proposta? Non avvierai un nuovo pagamento.', 'Non accetto la proposta')) { state.proposalBusy = false; return; }
    if (epoch !== state.sessionEpoch) { state.proposalBusy = false; return; }
    button.disabled = true;
    try {
      await request('proposal_decline', { method: 'POST', body: { proposalId } });
      state.proposalBusy = false;
      if (epoch === state.sessionEpoch && state.selected?.threadId === threadId) await openThread(state.selected, { quiet: true });
    } catch (_) {
      button.disabled = false;
      setMessageStatus('Non riesco a registrare la scelta. Riprova.');
    } finally { state.proposalBusy = false; }
  }

  function renderConversationEvent(event = {}) {
    const stateName = String(event.state || 'open').replace(/[^a-z_]/g, '') || 'open';
    const positive = ['accepted', 'captured', 'approved', 'prepared', 'fulfilled', 'resolved'].includes(stateName);
    const warning = ['failed', 'change_requested', 'cancelled'].includes(stateName);
    const icon = positive
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>'
      : warning
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8v5m0 3h.01M10.3 4.7 2.8 18a2 2 0 0 0 1.7 3h15a2 2 0 0 0 1.7-3L13.7 4.7a2 2 0 0 0-3.4 0Z"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
    const actions = (Array.isArray(event.actions) ? event.actions : []).map((action) => {
      const href = safeUrl(action.href);
      const className = `florame-messages__event-action is-${escapeHtml(action.style || 'secondary')}`;
      if (action.enabled === false) return `<button class="${className}" type="button" disabled>${escapeHtml(action.label || 'Apri')}</button>`;
      if (href) return `<a class="${className}" href="${escapeHtml(href)}">${escapeHtml(action.label || 'Apri')}</a>`;
      return `<button class="${className}" type="button" data-message-event-action="${escapeHtml(action.action || action.id || '')}">${escapeHtml(action.label || 'Apri')}</button>`;
    }).join('');
    const amount = Number(event.amountCents || 0) > 0 ? `<span>${escapeHtml(formatPrice(event.amountCents, event.currency))}</span>` : '';
    return `<article class="florame-messages__event is-${escapeHtml(stateName)}">
      <i class="florame-messages__event-icon">${icon}</i>
      <div class="florame-messages__event-copy"><strong>${escapeHtml(event.title || 'Aggiornamento')}</strong>${event.detail ? `<p>${escapeHtml(event.detail)}</p>` : ''}${amount}${actions ? `<div class="florame-messages__event-actions">${actions}</div>` : ''}</div>
    </article>`;
  }

  function contextLabel(item) {
    if (item?.conversationKind === 'florame') return 'Aggiornamenti Florame';
    if (item?.contextType === 'request') return `Richiesta${item.orderNumber ? ` · ${item.orderNumber}` : ''}`;
    if (item?.contextType === 'order') return `Ordine${item.orderNumber ? ` · ${item.orderNumber}` : ''}`;
    return 'Conversazione con il fiorista';
  }

  function requestState(item) {
    if (item?.orderDetail?.lifecycle) return [item.orderDetail.lifecycle.label,item.orderDetail.lifecycle.description];
    const phase = item?.orderDetail?.status;
    if (phase === 'prepared') return ['Bouquet pronto', 'La preparazione è terminata · segui la consegna nei dettagli'];
    if (phase === 'fulfilled') return ['Preparazione completata', 'Consulta nei dettagli lo stato del ritiro o della consegna'];
    if (phase === 'replaced') return ['Ordine sostituito', 'Questa è la conversazione dell’ordine iniziale'];
    const value = String(item?.requestStatus || '').toLowerCase();
    const states = {
      awaiting_partner: ['Richiesta inviata', 'In attesa della conferma del fiorista'],
      awaiting_manual_florist: ['Richiesta inviata', 'Florame sta cercando un fiorista per la tua consegna'],
      accepted: ['Richiesta confermata', 'Il fiorista ha accettato · pagamento acquisito'],
      cancelled: ['Ordine annullato', 'Consulta il pagamento e l’eventuale rimborso nei dettagli'],
      declined: ['Richiesta non accettata', 'Importo in annullamento o rimborso'],
      expired: ['Richiesta scaduta', 'Importo in annullamento o rimborso'],
      counter_proposed: ['Hai una nuova proposta', 'Nuovo pagamento solo se decidi di continuare'],
      proposal_declined: ['Proposta non accettata', 'Nessun nuovo addebito'],
      proposal_expired: ['Proposta scaduta', 'Nessun nuovo addebito'],
      payment_processing: ['Conferma pagamento', 'Il fiorista ha accettato · pagamento in verifica'],
      payment_failed: ['Pagamento da verificare', 'Segui le indicazioni nello stato ufficiale dell’ordine']
    };
    return states[value] || ['Richiesta al fiorista', 'Stato aggiornato da Florame'];
  }

  function requestGuide(item) {
    if (item?.orderDetail?.lifecycle?.guide) return item.orderDetail.lifecycle.guide;
    const phase = item?.orderDetail?.status;
    if (phase === 'prepared') return ['Richiesta accettata', 'Bouquet pronto', 'Controlla lo stato della consegna nei dettagli'];
    if (phase === 'fulfilled') return ['Richiesta accettata', 'Preparazione completata', 'Consulta consegna e assistenza nei dettagli'];
    if (phase === 'replaced') return ['Ordine iniziale sostituito', 'La nuova proposta ha un ordine dedicato', 'Segui il nuovo ordine dai tuoi ordini'];
    const value = String(item?.requestStatus || '').toLowerCase();
    if (value === 'cancelled') return ['Ordine annullato', 'Preparazione e consegna interrotte', 'Controlla nei dettagli lo stato del pagamento'];
    if (value === 'counter_proposed') {
      return ['Controlla il nuovo bouquet e il prezzo', 'Rivedi consegna e totale', 'Continua al nuovo checkout solo se accetti'];
    }
    if (value === 'proposal_declined' || value === 'proposal_expired') {
      return ['Proposta conclusa', 'Nessun nuovo addebito', 'Scrivici per valutare un’altra soluzione'];
    }
    if (value === 'accepted') {
      return ['Richiesta accettata', 'Pagamento acquisito', 'Il fiorista prepara il tuo ordine'];
    }
    if (value === 'declined' || value === 'expired') {
      return ['Richiesta conclusa', 'Importo in annullamento o rimborso', 'I tempi dipendono dal metodo di pagamento'];
    }
    if (value === 'payment_processing' || value === 'payment_failed') {
      return ['Richiesta accettata', 'Pagamento in verifica', 'Non inviare una seconda richiesta'];
    }
    return ['Richiesta inviata', 'Il fiorista risponde qui', 'Controlla qui la conferma dell’ordine'];
  }

  async function request(action, { method = 'GET', query = {}, body = null } = {}) {
    if (demoMode) return demo.request(action, { ...query, ...body });
    const url = new URL(apiPath, location.origin);
    url.searchParams.set('action', action);
    Object.entries(query).forEach(([key, value]) => {
      if (value !== '' && value != null) url.searchParams.set(key, String(value));
    });
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url.toString(), {
        method,
        credentials: 'same-origin',
        cache: 'no-store',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify({ action, ...body }) : undefined,
        signal: controller.signal
      });
      const payload = await response.json().catch(() => ({}));
      if (response.status === 401) throw Object.assign(new Error(payload.error || 'LOGIN_REQUIRED'), { status: 401 });
      if (!response.ok || payload?.success === false) throw Object.assign(new Error(payload?.error || 'MESSAGES_UNAVAILABLE'), { status: response.status, retryAfterMs: Number(payload?.retryAfterMs || 0) });
      return payload;
    } finally { clearTimeout(timer); }
  }

  function requestAuthentication(trigger, intent = 'messages_inbox') {
    if (demoMode) return demo.note();
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    if (window.FlorameAccountCenter?.requestAuth) {
      window.FlorameAccountCenter.requestAuth({ intent, returnTo, trigger: trigger || null });
      return;
    }
    window.__floramePendingAuthRequest = { intent, returnTo, trigger: trigger || null };
    window.dispatchEvent(new CustomEvent('florame:request-auth', {
      detail: { intent, returnTo, trigger: trigger || null }
    }));
  }

  function loginState() {
    state.threads = [{
      threadId: 'florame-welcome-guest',
      conversationKind: 'florame',
      contextType: 'announcement',
      partnerName: 'Florame',
      lastMessage: 'Benvenuto in Florame: qui troverai aggiornamenti utili, offerte e tutorial.',
      updatedAt: new Date().toISOString(),
      readOnly: true,
      guestStatic: true
    }];
    renderList();
    list.insertAdjacentHTML('beforeend', `<div class="florame-messages__empty florame-messages__auth-gate"><h2>Le tue conversazioni, al sicuro</h2><p>Accedi per scrivere ai fioristi e seguire richieste e ordini.</p><button class="florame-messages__save" type="button" data-messages-auth data-florame-auth-trigger data-florame-auth-intent="messages_inbox">Accedi o registrati</button></div>`);
    if (matchMedia('(min-width: 900px)').matches) openThread(state.threads[0], { quiet: true });
    if (initialOrderId || new URL(location.href).searchParams.get('thread')) {
      requestAnimationFrame(() => requestAuthentication(null, 'messages_private_thread'));
    }
    setMessageStatus('');
  }

  function sortThreads(items) {
    return [...items].sort((a, b) => {
      if (a.conversationKind === 'florame' && b.conversationKind !== 'florame') return -1;
      if (b.conversationKind === 'florame' && a.conversationKind !== 'florame') return 1;
      return String(b.updatedAt || b.lastMessageAt || '').localeCompare(String(a.updatedAt || a.lastMessageAt || ''));
    });
  }

  const mergeRows = (before, rows, key) => [...new Map([...before, ...rows].map(row => [row[key], row])).values()];
  function appendMoreThreads() {
    if (!state.listCursor) return;
    list.insertAdjacentHTML('beforeend', '<button type="button" class="florame-messages__save" data-more-threads>Altre conversazioni</button>');
    $('[data-more-threads]', list).addEventListener('click', async event => { event.currentTarget.disabled = true; await loadInbox({ cursor: state.listCursor }); });
  }
  async function olderMessages() {
    if (state.pageBusy || !state.messagesCursor || !state.selected) return;
    state.pageBusy = true;
    const control = $('[data-older-messages]', messagesNode);
    if (control) { control.disabled = true; control.textContent = 'Carico…'; }
    const id = state.selected.threadId, sequence = state.openSequence;
    try {
      const payload = await request('thread', { query: { threadId: id, messagesCursor: state.messagesCursor } });
      if (state.selected?.threadId !== id || sequence !== state.openSequence) return;
      state.messages = mergeRows(payload.messages || [], state.messages, 'messageId');
      state.messagesCursor = payload.messagesCursor || '';
      state.historyExpanded = true;
      renderMessages({ prepend: true });
    } catch { setMessageStatus('Non riusciamo a caricare i messaggi precedenti. Riprova.'); }
    finally { state.pageBusy = false; if (control?.isConnected) { control.disabled = false; control.textContent = 'Messaggi precedenti'; } }
  }

  function renderList() {
    const query = state.search.toLocaleLowerCase('it');
    const visible = sortThreads(state.threads).filter((item) => (state.filter !== 'unread' || Number(item.customerUnreadCount) > 0) && (state.filter !== 'orders' || ['request', 'order'].includes(item.contextType)) && (!query || [item.partnerName, item.lastMessage, contextLabel(item)].join(' ').toLocaleLowerCase('it').includes(query)));
    if (!visible.length) {
      list.innerHTML = `<div class="florame-messages__empty"><strong>Nessuna conversazione trovata</strong><p>Prova con un altro nome o messaggio.</p></div>`;
      appendMoreThreads();
      return;
    }
    list.innerHTML = visible.map((item) => {
      const florame = item.conversationKind === 'florame';
      const preview = item.lastMessage || (item.contextType === 'request' ? 'Segui qui la richiesta al fiorista' : 'Apri la conversazione');
      const privatePreview = item.lastMessage && !florame && !['system', 'florame'].includes(item.lastMessageSender);
      return `<button class="florame-messages__row${state.selected?.threadId === item.threadId ? ' is-active' : ''}" aria-current="${state.selected?.threadId === item.threadId ? 'true' : 'false'}" type="button" data-thread-id="${escapeHtml(item.threadId)}">
        ${avatar(item)}
        <span class="florame-messages__row-copy">
          <span class="florame-messages__row-title"><strong>${escapeHtml(item.partnerName || 'Fiorista Florame')}</strong>${florame ? '<i class="florame-messages__verified" title="Canale ufficiale Florame">✓</i>' : ''}</span>
          <span class="florame-messages__preview"${privatePreview ? ' translate="no" data-florame-no-translate' : ''}>${escapeHtml(preview)}</span>
          <span class="florame-messages__meta">${escapeHtml(contextLabel(item))}</span>
        </span>
        <span class="florame-messages__row-side"><time>${escapeHtml(relativeTime(item.lastMessageAt || item.updatedAt))}</time>${Number(item.customerUnreadCount || 0) ? `<i class="florame-messages__unread">${Math.min(99, Number(item.customerUnreadCount))}</i>` : ''}</span>
      </button>`;
    }).join('');
    appendMoreThreads();
    $$('[data-thread-id]', list).forEach((button) => button.addEventListener('click', () => {
      const selected = state.threads.find((item) => item.threadId === button.dataset.threadId);
      if (selected) openThread(selected);
    }));
  }

  function renderContext(item) {
    const node = $('[data-messages-context]');
    // Message previews/unread receipts do not change the bouquet. Preserve the
    // card, photo opener and entry animation until its actual order data changes.
    const signature = JSON.stringify(item && {locale:getLocale(), threadId:item.threadId, contextType:item.contextType, requestStatus:item.requestStatus, requestSummary:item.requestSummary, requestResponseDeadlineAt:item.requestResponseDeadlineAt, orderId:item.orderId, orderNumber:item.orderNumber, orderDetail:item.orderDetail});
    if (node.__contextSignature === signature) return;
    const sameThread = node.dataset.contextThread === item?.threadId;
    const focusedDetail = sameThread && node.contains(document.activeElement) ? document.activeElement.closest('[data-bouquet-detail]')?.dataset.bouquetDetail : '';
    const openDetails = sameThread ? [...node.querySelectorAll('details[open]')].map(el => el.dataset.bouquetDetail || 'more') : [];
    node.dataset.contextThread = item?.threadId || '';
    node.__contextSignature = signature;
    if (!item || !['request', 'order'].includes(item.contextType)) {
      node.hidden = true;
      node.innerHTML = '';
      $('[data-messages-product-shortcut]').hidden = true;
      return;
    }
    const request = item.contextType === 'request';
    const [title, subtitle] = request ? requestState(item) : ['Ordine Florame', `Ordine ${item.orderNumber || ''}`.trim()];
    const summary = item.requestSummary || {};
    const amount = summary.totalPrice ? new Intl.NumberFormat(getLocale(), { style: 'currency', currency: summary.currency || 'EUR' }).format(Number(String(summary.totalPrice).replace(',', '.')) || 0) : '';
    const delivery = [summary.deliveryDate ? formatDeliveryDate(summary.deliveryDate) : '', summary.deliveryTime].filter(Boolean).join(' · ');
    const paymentLabel = item.orderDetail?.payment?.label || 'Pagamento da confermare';
    const requestPolicy = item.orderDetail?.lifecycle?.policy || (['cancelled','declined','expired','proposal_declined','proposal_expired'].includes(item.requestStatus) ? 'Richiesta conclusa' : item.orderDetail?.status === 'replaced' ? 'Ordine iniziale sostituito' : item.requestStatus === 'accepted' ? 'Disponibilità confermata dal fiorista' : summary.requestKind === 'stock_confirmed'
      ? 'Fiori verificati nello stock'
      : 'Disponibilità da confermare');
    const image = safeImage(summary.imageUrl);
    const guide = request ? requestGuide(item) : [];
    node.innerHTML = `<span class="florame-messages__context-kicker">${request ? 'Richiesta al fiorista' : 'Ordine'}</span><h3>${escapeHtml(title)}</h3><div class="florame-messages__context-meta"><span>${escapeHtml(subtitle)}</span>${item.requestResponseDeadlineAt && item.requestStatus === 'awaiting_partner' ? `<span>Risposta entro ${escapeHtml(new Date(item.requestResponseDeadlineAt).toLocaleString(getLocale(), { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }))}</span>` : ''}</div>${request && (summary.title || image) ? `<div class="florame-messages__request-card"><span><strong>${escapeHtml(summary.title || 'Bouquet Florame')}</strong>${delivery ? `<span>${escapeHtml(delivery)}</span>` : ''}<span>${escapeHtml(requestPolicy)}</span>${amount ? `<span>${escapeHtml(amount)} · ${escapeHtml(paymentLabel)}</span>` : ''}</span>${image ? renderPhoto(image, summary.title, 74) : ''}</div>` : ''}${request ? `<ol class="florame-messages__request-flow">${guide.map((step, index) => `<li><i>${index + 1}</i><span>${escapeHtml(step)}</span></li>`).join('')}</ol>` : ''}${item.orderDetail ? '<button class="florame-messages__context-open" type="button" data-messages-open-order>Apri ordine o richiesta <span aria-hidden="true">›</span></button>' : ''}`;
    if (request) {
      node.querySelector('.florame-messages__request-card')?.remove();
      const composition = (summary.composition || []).filter(row => row.label);
      const count = composition.reduce((sum, row) => sum + row.quantity, 0);
      const packaging = [['Carta', summary.packaging?.paper], ['Nastro', summary.packaging?.ribbon], ['Decorazioni', (summary.packaging?.decorations || []).join(' · ')]].filter(row => row[1]).map(([label,value]) => [label,materialLabel(value)]);
      const svg = path => `<svg viewBox="0 0 24 24" aria-hidden="true">${path}</svg>`;
      const flowerIcon = svg('<path d="M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1"/><circle cx="12" cy="8" r="2"/><path d="M12 10v12M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5ZM12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z"/>');
      const giftIcon = svg('<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13M12 8C4 8 5 1 9 3l3 5c8 0 7-7 3-5l-3 5"/>');
      const detail = (key, label, icon, body) => `<details data-bouquet-detail="${key}" class="florame-messages__bouquet-detail" ${openDetails.includes(key) ? 'open' : ''}><summary><i>${icon}</i><span>${label}</span><b aria-hidden="true">⌄</b></summary><div>${body}</div></details>`;
      const article = document.createElement('article');
      article.className = 'florame-messages__requested-bouquet'; article.dataset.requestedBouquet = ''; article.tabIndex = -1;
      article.setAttribute('aria-label', 'Bouquet richiesto');
      article.innerHTML = `<div class="florame-messages__bouquet-hero">${image ? renderPhoto(image, summary.title, 108) : `<span class="florame-messages__bouquet-placeholder" aria-label="Foto non disponibile">${flowerIcon}</span>`}<div><small>Il bouquet richiesto</small><h4>${escapeHtml(summary.title || 'Bouquet su richiesta')}</h4>${count ? `<span class="florame-messages__bouquet-count">${count} steli · ${composition.length} ${composition.length === 1 ? 'varietà' : 'varietà'}</span>` : ''}<span class="florame-messages__bouquet-policy">${escapeHtml(requestPolicy)}</span></div></div><div class="florame-messages__bouquet-facts">${delivery ? `<span><small>${item.orderDetail?.delivery?.method === 'pickup' ? 'Ritiro' : 'Consegna'}</small><strong>${escapeHtml(delivery)}</strong></span>` : ''}${amount ? `<span><small>Totale ordine</small><strong>${escapeHtml(amount)}</strong><em>${escapeHtml(paymentLabel)}</em></span>` : ''}</div>${detail('composition', count ? `Composizione · ${count} steli` : 'Composizione', flowerIcon, composition.length ? `<ul>${composition.map(row => `<li><b>${row.quantity}×</b><span>${escapeHtml(row.label)}${row.color && !row.label.toLowerCase().includes(row.color.toLowerCase()) ? `<small>${escapeHtml(row.color)}</small>` : ''}</span></li>`).join('')}</ul>` : '<p>La composizione non è presente nel riepilogo di questa richiesta. Puoi chiederla al fiorista nella chat.</p>')}${detail('packaging', 'Carta, nastro e decorazioni', giftIcon, packaging.length ? `<dl>${packaging.map(([label, value]) => `<div><dt>${label}</dt><dd>${escapeHtml(value)}</dd></div>`).join('')}</dl>` : '<p>Confezione e decorazioni non sono specificate in questa richiesta. Concordale con il fiorista nella chat.</p>')}${summary.description ? detail('description', 'Il bouquet in dettaglio', flowerIcon, `<p>${escapeHtml(summary.description)}</p>`) : ''}<button class="florame-messages__bouquet-ask" type="button" data-bouquet-ask>Parliamone in chat <span aria-hidden="true">↗</span></button>`;
      node.querySelector('.florame-messages__context-meta').after(article);
      const shortcut = $('[data-messages-product-shortcut]');
      shortcut.hidden = false;
      shortcut.innerHTML = `${image ? `<img src="${escapeHtml(image)}" alt="" width="32" height="32">` : flowerIcon}<span><small>Il tuo bouquet</small><strong>${escapeHtml(summary.title || 'Bouquet su richiesta')}</strong></span><b>Dettagli <span aria-hidden="true">⌄</span></b>`;
      $('[data-bouquet-ask]', article).addEventListener('click', () => {
        if (!draft.value.trim()) { draft.value = 'Vorrei parlare di composizione e decorazioni del bouquet richiesto.'; draft.dispatchEvent(new Event('input', { bubbles: true })); }
        draft.focus();
      });
    } else $('[data-messages-product-shortcut]').hidden = true;
    const existingDetails = node.querySelector('[data-context-more]');
    if(!existingDetails) {
      const details = document.createElement('details'); details.dataset.contextMore = ''; details.open = openDetails.includes('more');
      details.innerHTML = '<summary>Dettagli e prossimi passi</summary>';
      [...node.querySelectorAll('.florame-messages__request-flow')].forEach(child=>details.appendChild(child));
      if(details.children.length > 1) node.appendChild(details);
    }
    node.hidden = false;
    if(item.orderId && !demoMode) {
      const report=document.createElement('button');report.type='button';report.className='florame-messages__context-open';report.dataset.reportOrderProblem='';report.innerHTML='⚠️ <span>Segnala un problema</span>';
      report.addEventListener('click',openOrderProblem);node.appendChild(report);
    }
    $('[data-messages-open-order]', node)?.addEventListener('click', openOrderDetails);
    if (focusedDetail) node.querySelector(`[data-bouquet-detail="${focusedDetail}"]>summary`)?.focus({ preventScroll: true });
  }

  $('[data-messages-product-shortcut]').addEventListener('click', () => {
    const card = $('[data-requested-bouquet]');
    if (!card) return;
    scrollNode.scrollTo({ top: Math.max(0, scrollNode.scrollTop + card.getBoundingClientRect().top - scrollNode.getBoundingClientRect().top - 12), behavior: reducedMotion() ? 'instant' : 'smooth' });
    card.focus({ preventScroll: true });
  });

  function formatDeliveryDate(value) {
    if (!String(value || '').trim()) return 'Da definire';
    const parsed = new Date(`${String(value).slice(0, 10)}T12:00:00`);
    if (Number.isNaN(parsed.getTime())) return String(value);
    return parsed.toLocaleDateString(getLocale(), { weekday: 'long', day: 'numeric', month: 'long' });
  }

  function openOrderDetails() {
    const item = state.selected;
    if (demoMode && item?.orderId) { location.href = demo.link('/pages/florame-account', { orderId: item.orderId }); return; }
    if (item?.orderId) {
      const params = new URLSearchParams({ orderId: item.orderId });
      if (item.threadId) params.set('thread', item.threadId);
      location.href = `/pages/florame-order?${params.toString()}`;
      return;
    }
    const detail = item?.orderDetail;
    if (!detail || !orderSheet) return;
    const delivery = detail.delivery || {};
    const payment = detail.payment || {};
    const items = Array.isArray(detail.items) ? detail.items : [];
    const timeline = Array.isArray(detail.timeline) ? detail.timeline : [];
    $('[data-messages-order-kicker]').textContent = item.contextType === 'request' ? 'Richiesta al fiorista' : 'Ordine Florame';
    $('[data-messages-order-title]').textContent = item.orderNumber ? `Ordine ${item.orderNumber}` : (detail.statusLabel || 'Dettagli');
    $('[data-messages-order-content]').innerHTML = `
      <section class="florame-messages__order-status" data-state="${escapeHtml(detail.status || '')}">
        <small>Stato ufficiale</small><strong>${escapeHtml(detail.statusLabel || 'Aggiornato')}</strong>
      </section>
      <section class="florame-messages__order-block">
        <h3>Pagamento</h3>
        <div class="florame-messages__order-info"><span class="florame-messages__order-info-icon" aria-hidden="true">✓</span><span><strong>${escapeHtml(payment.label || 'Pagamento aggiornato')}</strong><small>${escapeHtml(payment.detail || '')}</small></span></div>
      </section>
      <section class="florame-messages__order-block">
        <h3>${delivery.method === 'pickup' ? 'Ritiro' : 'Consegna'}</h3>
        <dl class="florame-messages__order-facts">
          <div><dt>Quando</dt><dd translate="no" data-florame-no-translate>${escapeHtml(formatDeliveryDate(delivery.date))}${delivery.time ? ` · ${escapeHtml(delivery.time)}` : ''}</dd></div>
          ${delivery.recipient ? `<div><dt>Per chi</dt><dd translate="no" data-florame-no-translate>${escapeHtml(delivery.recipient)}</dd></div>` : ''}
          ${delivery.address ? `<div><dt>Dove</dt><dd translate="no" data-florame-no-translate>${escapeHtml(delivery.address)}</dd></div>` : ''}${delivery.access ? `<div><dt>Accesso</dt><dd translate="no" data-florame-no-translate>${escapeHtml(delivery.access)}</dd></div>` : ''}${delivery.doorbell ? `<div><dt>Citofono</dt><dd translate="no" data-florame-no-translate>${escapeHtml(delivery.doorbell)}</dd></div>` : ''}${delivery.notes ? `<div><dt>Istruzioni</dt><dd translate="no" data-florame-no-translate>${escapeHtml(delivery.notes)}</dd></div>` : ''}
        </dl>
        ${delivery.changeCopy ? `<p class="florame-messages__change-policy"><strong>${escapeHtml(delivery.changeTitle || (['request_change', 'self_service'].includes(delivery.changePolicy) ? 'Puoi ancora chiedere una modifica' : 'Prima di modificare, scrivi al fiorista'))}</strong>${escapeHtml(delivery.changeCopy)}</p>` : ''}
      </section>
      ${items.length ? `<section class="florame-messages__order-block"><h3>Cosa hai scelto</h3><div class="florame-messages__order-items">${items.map((product) => {
        const productImage = safeImage(product.imageUrl);
        return `<div>${productImage ? `${window.FlorameImageVariants?.html(`<img src="${escapeHtml(productImage)}" alt="" width="54" height="54" loading="lazy">`, "54px") || `<img src="${escapeHtml(productImage)}" alt="" width="54" height="54" loading="lazy">`}` : '<span class="florame-messages__order-item-placeholder" aria-hidden="true">✿</span>'}<span><strong>${escapeHtml(product.title || 'Bouquet Florame')}</strong><small>${product.kind === 'extra' ? 'Extra' : 'Bouquet'} · quantità ${Math.max(1, Number(product.quantity || 1))}</small></span></div>`;
      }).join('')}</div></section>` : ''}
      ${timeline.length ? `<section class="florame-messages__order-block"><h3>A che punto siamo</h3><ol class="florame-messages__timeline">${timeline.map((event) => `<li class="is-${escapeHtml(event.state || 'upcoming')}"><i aria-hidden="true"></i><span><strong>${escapeHtml(event.label || '')}</strong>${event.detail ? `<small>${escapeHtml(event.detail)}</small>` : ''}${event.at ? `<time>${escapeHtml(new Date(event.at).toLocaleString(getLocale(), { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }))}</time>` : ''}</span></li>`).join('')}</ol></section>` : ''}`;
    rememberSheetOpener(orderSheet);
    orderSheet.hidden = false;
    document.body.classList.add('florame-messages-overlay-open');
    document.documentElement.style.overflow = 'hidden';
    const params = new URLSearchParams(location.search);
    params.set('view', 'order');
    if (item.orderId) params.set('orderId', item.orderId);
    history.replaceState(history.state, '', `${location.pathname}?${params.toString()}`);
    requestAnimationFrame(() => $('.florame-messages__order-panel', orderSheet)?.focus());
  }

  function closeOrderDetails({ restoreUrl = true } = {}) {
    if (!orderSheet) return;
    orderSheet.hidden = true;
    restoreSheetOpener(orderSheet);
    if (settings.hidden && detailsSheet.hidden) document.body.classList.remove('florame-messages-overlay-open');
    document.documentElement.style.removeProperty('overflow');
    if (restoreUrl) {
      const params = new URLSearchParams(location.search);
      params.delete('view');
      history.replaceState(history.state, '', `${location.pathname}${params.toString() ? `?${params.toString()}` : ''}`);
    }
    $('[data-messages-open-order]')?.focus();
  }

  function confirmationKey(message) {
    if (message.proposal) return 'proposal:' + message.proposal.proposalId;
    if (!message.event || !['accepted', 'captured'].includes(message.event.state)) return '';
    const order = message.event.orderId || state.selected?.orderId;
    const matching = state.messages.find(row => row.proposal?.status === 'accepted' && row.proposal.replacementOrderId === order);
    return matching ? 'proposal:' + matching.proposal.proposalId : order ? 'order:' + order : '';
  }
  function celebrate(node, message) {
    const key = confirmationKey(message);
    if (!key) return;
    const accepted = message.proposal ? message.proposal.status === 'accepted' : true;
    const previous = observedConfirmations.get(key);
    observedConfirmations.set(key, accepted);
    let returning = false;
    try { const resume = JSON.parse(sessionStorage.getItem('florame_counter_proposal_resume_v1') || 'null'); returning = key === 'proposal:' + resume?.proposalId && Date.now() - resume.savedAt < 86400000; } catch (_) {}
    if (!accepted || confirmations.has(key)) return;
    confirmations.add(key); saveSession();
    if ((previous !== false && !returning) || reducedMotion()) return;
    const surface = node.querySelector('.florame-messages__proposal,.florame-messages__event');
    if (!surface) return;
    const rect = surface.getBoundingClientRect(), area = scrollNode.getBoundingClientRect();
    if(rect.bottom < area.top || rect.top > area.bottom) return;
    window.FlorameMotion?.confirm?.(surface);
    const bloom = document.createElement('span'); bloom.className = 'florame-messages__bloom'; bloom.setAttribute('aria-hidden','true');
    bloom.innerHTML = '<svg viewBox="0 0 24 24"><path d="m5 12 4 4L19 6"/></svg>' + Array.from({length:8},(_,i)=>'<i style="--petal:' + i + '"></i>').join('');
    surface.appendChild(bloom); setTimeout(()=>bloom.remove(),850);
  }
  function renderMessageAttachments(files) {
    return (Array.isArray(files)?files:[]).filter(file=>/^https:\/\/firebasestorage\.googleapis\.com\/v0\/b\//.test(file?.url||'')).map(file=>'<a class="florame-messages__file" href="'+escapeHtml(file.url)+'" target="_blank" rel="noopener noreferrer">'+(String(file.mime).startsWith('image/')?'<img src="'+escapeHtml(file.url)+'" alt="'+escapeHtml(file.name)+'" loading="lazy">':'')+'<span><strong>'+escapeHtml(file.name)+'</strong><small>'+Math.max(1,Math.round(Number(file.size)/1024))+' KB · Apri allegato</small></span></a>').join('');
  }

  function renderMessages({ keepScroll = false, prepend = false } = {}) {
    const oldTop = scrollNode.scrollTop, oldHeight = scrollNode.scrollHeight;
    const item = state.selected, sequence = state.openSequence;
    const areaTop = scrollNode.getBoundingClientRect().top;
    const anchor = [...messagesNode.children].find(node => node.dataset.messageKey && node.getBoundingClientRect().bottom > areaTop);
    const anchorKey = anchor?.dataset.messageKey, anchorOffset = anchor ? anchor.getBoundingClientRect().top - areaTop : 0;
    const existing = new Map([...messagesNode.children].filter(node => node.dataset.messageKey).map(node => [node.dataset.messageKey, node]));
    renderContext(item);
    if (item?.orderId && ['awaiting_partner','awaiting_manual_florist','assigned','payment_processing','counter_proposed'].includes(item.requestStatus)) observedConfirmations.set('order:' + item.orderId, false);
    const rows = [...state.messages, ...outboxMessages()];
    clearTimeout(proposalExpiryTimer);
    const nextExpiry = Math.min(...rows.filter(row => row.proposal && ['available','sent','viewed','checkout_started','payment_failed'].includes(row.proposal.status)).map(row => Date.parse(row.proposal.expiresAt)).filter(at => at > Date.now()));
    if (Number.isFinite(nextExpiry)) proposalExpiryTimer = setTimeout(() => {
      if (sequence === state.openSequence && state.threadReady && !state.authExpired) renderMessages({ keepScroll: true });
    }, Math.min(2147483647, Math.max(1, nextExpiry - Date.now())));
    let prior = null, priorDay = '';
    const html = rows.length ? rows.map((message, index) => {
      const own = message.sender === 'customer', sender = own ? 'Tu' : message.sender === 'partner' ? item?.partnerName || 'Fiorista' : 'florame.ai';
      const proposal = message.kind === 'proposal' && message.proposal ? message.proposal : null;
      const event = message.kind === 'event' && message.event ? message.event : null;
      const timestamp = event?.occurredAt && Number.isFinite(Date.parse(event.occurredAt)) ? event.occurredAt : message.createdAt;
      const time = new Date(timestamp), valid = !Number.isNaN(time.getTime());
      const day = valid ? time.toLocaleDateString(getLocale(),{day:'numeric',month:'long'}) : '';
      const grouped = prior && !proposal && !event && !prior.proposal && !prior.event && prior.sender === message.sender && day === priorDay && Math.abs(time - new Date(prior.createdAt)) < 300000;
      const separator = day && day !== priorDay ? '<div class="florame-messages__day" data-message-key="day-' + escapeHtml(message.messageId || index) + '">' + escapeHtml(day) + '</div>' : '';
      prior = message; priorDay = day;
      const local = message.localStatus;
      const label = message.verifying ? 'Verifico l’invio…' : local === 'queued' ? (navigator.onLine ? 'In coda' : 'In attesa di connessione') : local === 'sending' ? 'In invio' : local === 'uncertain' ? 'Invio da verificare' : local === 'failed' ? 'Non inviato' : own ? 'Inviato' : '';
      const controls = local === 'uncertain' || local === 'failed' ? '<span class="florame-messages__send-recovery"><button type="button" data-message-retry="' + escapeHtml(message.clientRequestId) + '"' + (message.verifying ? ' disabled aria-busy="true"' : '') + '>Verifica e riprova</button><button type="button" data-message-edit="' + escapeHtml(message.clientRequestId) + '"' + (message.verifying ? ' disabled' : '') + '>Modifica</button></span>' : '';
      const clock = valid ? time.toLocaleTimeString(getLocale(),{hour:'2-digit',minute:'2-digit'}) : '';
      return separator + '<div data-message-key="' + escapeHtml(message.messageId || 'message-' + index) + '" class="florame-messages__message' + (own ? ' florame-messages__message--customer' : '') + (proposal ? ' florame-messages__message--proposal' : '') + (event ? ' florame-messages__message--event' : '') + (grouped ? ' is-grouped' : '') + '" data-send-state="' + escapeHtml(local || '') + '"><p class="florame-messages__message-label">' + escapeHtml(sender) + '</p>' + (event ? renderConversationEvent(event) : '<div class="florame-messages__bubble">' + '<span' + (['customer', 'partner'].includes(message.sender) && !proposal ? ' translate="no" data-florame-no-translate' : '') + '>' + escapeHtml(message.text) + '</span>' + renderMessageAttachments(message.attachments) + (proposal ? renderProposalCard(proposal) : '') + '</div>') + '<div class="florame-messages__message-meta"><time datetime="' + escapeHtml(timestamp || '') + '">' + escapeHtml(clock) + '</time><span>' + label + '</span></div>' + (message.localError ? '<small class="florame-messages__send-error">' + escapeHtml(message.localError) + '</small>' : '') + controls + '</div>';
    }).join('') : '<div class="florame-messages__empty"><p>Scrivi il primo messaggio: il fiorista lo vedrà nel suo Hub.</p></div>';
    const template = document.createElement('template'); template.innerHTML = html;
    let newCount = 0;
    const nodes = [...template.content.children].map(node => {
      const previous = existing.get(node.dataset.messageKey), signature = node.outerHTML;
      if (previous?.__messageMarkup === signature) return previous;
      node.__messageMarkup = signature;
      if(previous) {
        [...previous.querySelectorAll('details')].forEach((detail,i)=> { if(detail.open && node.querySelectorAll('details')[i]) node.querySelectorAll('details')[i].open = true; });
        if(previous.contains(document.activeElement)) {
          const action = document.activeElement.dataset.proposalAction;
          requestAnimationFrame(()=> { if(sequence === state.openSequence && action) node.querySelector('[data-proposal-action="' + CSS.escape(action) + '"]')?.focus({preventScroll:true}); });
        }
      } else if (existing.size && !prepend && node.classList.contains('florame-messages__message')) {
        if(!node.classList.contains('florame-messages__message--customer')) newCount++;
        if(!reducedMotion()) node.classList.add('is-arriving');
      }
      return node;
    });
    nodes.forEach((node,index)=> { if(messagesNode.children[index] !== node) messagesNode.insertBefore(node,messagesNode.children[index] || null); });
    while(messagesNode.children.length > nodes.length) messagesNode.lastElementChild.remove();
    if(state.messagesCursor) {
      messagesNode.insertAdjacentHTML('afterbegin','<button type="button" class="florame-messages__save" data-older-messages>Messaggi precedenti</button>');
      $('[data-older-messages]',messagesNode).addEventListener('click',olderMessages);
    }
    // Apply known UI copy as soon as messages appear; authored text is protected above.
    window.FlorameI18n?.apply(root);
    const isReadonly = item?.readOnly === true || item?.conversationKind === 'florame';
    composer.hidden = isReadonly; readonly.hidden = !isReadonly;
    if(keepScroll) state.newMessages += newCount;
    requestAnimationFrame(()=> {
      if(sequence !== state.openSequence) return;
      const currentAnchor = anchorKey && [...messagesNode.children].find(node=>node.dataset.messageKey === anchorKey);
      const top = (keepScroll || prepend) && currentAnchor ? scrollNode.scrollTop + currentAnchor.getBoundingClientRect().top - areaTop - anchorOffset : prepend ? oldTop + scrollNode.scrollHeight - oldHeight : keepScroll ? oldTop : scrollNode.scrollHeight;
      scrollNode.scrollTo({top,behavior:'instant'}); updateLatest();
      rows.forEach(message=> { const node = [...messagesNode.children].find(node=>node.dataset.messageKey === message.messageId); if(node) celebrate(node,message); });
    });
  }

  function renderThreadHeader(item) {
    const avatarNode = $('[data-messages-thread-avatar]');
    if (avatarNode) avatarNode.outerHTML = avatar(item, true).replace('class="florame-messages__thread-avatar', 'data-messages-thread-avatar class="florame-messages__thread-avatar');
    $('[data-messages-thread-title]').textContent = item?.partnerName || 'Conversazione';
    $('[data-messages-thread-subtitle]').textContent = contextLabel(item);
    $('[data-messages-details]').hidden = item?.conversationKind === 'florame';
  }

  function openPartnerDetails() {
    const item = state.selected;
    if (!item || item.conversationKind === 'florame') return;
    const storefront = safeUrl(item.partnerStorefrontUrl || (item.partnerSlug ? `/pages/${encodeURIComponent(item.partnerSlug)}` : ''));
    const website = safeUrl(item.partnerWebsite);
    const phone = String(item.partnerPhone || '').trim();
    const address = String(item.partnerAddress || '').trim();
    $('[data-messages-partner-title]').textContent = 'Dettagli fiorista';
    $('[data-messages-partner-details]').innerHTML = `<div class="florame-messages__partner-profile">
      ${avatar(item)}
      <div><strong>${escapeHtml(item.partnerName || 'Fiorista Florame')}</strong>${item.partnerCity ? `<span>${escapeHtml(item.partnerCity)}</span>` : ''}</div>
    </div>
    <div class="florame-messages__partner-links">
      ${storefront ? `<a href="${escapeHtml(storefront)}"><span><b>Pagina del fiorista</b><small>Foto, bouquet e disponibilità</small></span><i aria-hidden="true">›</i></a>` : ''}
      ${address ? `<div><span><b>Indirizzo</b><small>${escapeHtml(address)}</small></span></div>` : ''}
      ${phone ? `<a href="tel:${escapeHtml(phone)}"><span><b>Telefono</b><small>${escapeHtml(phone)}</small></span><i aria-hidden="true">›</i></a>` : ''}
      ${website ? `<a href="${escapeHtml(website)}" target="_blank" rel="noopener"><span><b>Sito web</b><small>Apri in una nuova scheda</small></span><i aria-hidden="true">›</i></a>` : ''}
    </div>
    <p class="florame-messages__partner-note">Pagamenti, modifiche e rimborsi restano sempre gestiti da Florame. In chat puoi concordare preferenze e dettagli del bouquet.</p>`;
    rememberSheetOpener(detailsSheet);
    detailsSheet.hidden = false;
    document.body.classList.add('florame-messages-overlay-open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => $('.florame-messages__partner-sheet', detailsSheet)?.focus());
  }

  function closePartnerDetails() {
    detailsSheet.hidden = true;
    restoreSheetOpener(detailsSheet);
    if (settings.hidden) document.body.classList.remove('florame-messages-overlay-open');
    document.documentElement.style.removeProperty('overflow');
  }

  async function openThread(item, { quiet = false } = {}) {
    if (!item?.threadId || state.authExpired || (quiet && (state.threadLoading || state.proposalBusy))) return;
    const sequence = ++state.openSequence;
    if (!quiet) {
      if (state.selected) state.drafts.set(state.selected.threadId, draft.value);
      state.historyExpanded = false; state.messagesCursor = "";
      state.threadReady = false;
      draft.value = state.drafts.get(item.threadId) || '';
      setMessageStatus('');
      $('[data-messages-context]').hidden = true;
      $('[data-messages-context]').__contextSignature = null;
      if (latest) latest.hidden = true;
    }
    state.selected = item;
    state.threadLoading = true;
    updateComposer();
    thread.hidden = false;
    blank.hidden = true;
    root.classList.add('is-thread-open');
    renderThreadHeader(item);
    if (item.guestStatic) {
      state.threadLoading = false;
      state.messages = [{ sender: 'florame', text: item.lastMessage, createdAt: item.updatedAt }];
      renderMessages();
      return;
    }
    if (!quiet) {
      const cached = conversationMemory.get(item.threadId);
      if (cached) { state.messages = cached.messages; state.messagesCursor = cached.cursor; renderMessages(); }
      else messagesNode.innerHTML = window.FlorameSkeletons.message;
    }
    try {
      const payload = await request('thread', { query: { threadId: item.threadId, orderId: item.orderId || '' } });
      if (sequence !== state.openSequence || state.selected?.threadId !== item.threadId) return;
      state.selected = payload.thread || item;
      state.threadReady = true;
      setMessageStatus('');
      const received = Array.isArray(payload.messages) ? payload.messages : [];
      reconcileOutbox(received);
      if (state.outbox.find(row=>row.threadId === item.threadId && row.status !== 'sent')?.status === 'queued') void drainOutbox(item.threadId);
      state.messages = mergeRows(quiet ? state.messages : [], received, "messageId");
      conversationMemory.set(item.threadId, { messages: state.messages, cursor: payload.messagesCursor || '' });
      if (!quiet || !state.historyExpanded) state.messagesCursor = payload.messagesCursor || "";
      state.threads = state.threads.map((row) => row.threadId === state.selected.threadId ? state.selected : row);
      renderThreadHeader(state.selected);
      renderMessages({ keepScroll: quiet && scrollNode.scrollHeight - scrollNode.scrollTop - scrollNode.clientHeight > 100 });
      renderList();
      if (initialCompose === 'delivery_change' && !state.composePrepared && draft && !draft.value.trim()) {
        state.composePrepared = true;
        draft.value = 'Vorrei chiedere una modifica a data, fascia o indirizzo di consegna. La preferenza attuale deve restare valida finché non mi confermate la modifica.';
        draft.dispatchEvent(new Event('input', { bubbles: true }));
        draft.focus();
      }
      const shouldOpenOrderView = new URL(location.href).searchParams.get('view') === 'order';
      const threadParams = new URLSearchParams({ ...(initialPartner ? { partner: initialPartner } : {}), thread: state.selected.threadId });
      if (demoMode) { threadParams.set('demo', '1'); if (new URL(location.href).searchParams.get('lang')) threadParams.set('lang', new URL(location.href).searchParams.get('lang')); }
      if (state.selected.orderId) threadParams.set('orderId', state.selected.orderId);
      history.replaceState(history.state, '', `${location.pathname}?${threadParams.toString()}`);
      // An order ID identifies the conversation for push/history links. Only
      // an explicit detail-view request should leave Messages for the order.
      if (shouldOpenOrderView) {
        openOrderDetails();
      }
    } catch (error) {
      if (sequence !== state.openSequence || state.selected?.threadId !== item.threadId) return;
      if (error?.status === 401) { clearPrivateState(); return requestAuthentication(null, 'messages_thread'); }
      if (quiet) { setMessageStatus('Aggiornamento in pausa. I messaggi già caricati restano qui.'); return false; }
      messagesNode.innerHTML = '<div class="florame-messages__empty"><strong>La chat non si è aperta</strong><p>La tua bozza è al sicuro. Riproviamo?</p><button type="button" class="florame-messages__save" data-messages-thread-retry>Riprova</button></div>';
      $('[data-messages-thread-retry]').onclick = () => openThread(item);
    } finally {
      if (sequence === state.openSequence) { state.threadLoading = false; updateComposer(); }
    }
  }

  function closeThread() {
    if (state.selected) state.drafts.set(state.selected.threadId, draft.value);
    state.openSequence++;
    saveSession();
    state.selected = null;
    state.threadReady = false;
    state.threadLoading = false;
    closeOrderDetails({ restoreUrl: false });
    root.classList.remove('is-thread-open');
    if (matchMedia('(max-width: 899px)').matches) {
      thread.hidden = true;
      blank.hidden = false;
    }
    history.replaceState(history.state, '', demoMode ? demo.link(location.pathname, { partner: initialPartner }) : `${location.pathname}${initialPartner ? `?partner=${encodeURIComponent(initialPartner)}` : ''}`);
    renderList();
  }

  async function loadInbox({ quiet = false, cursor = "" } = {}) {
    if (state.inboxLoading || state.authExpired) return;
    state.inboxLoading = true; const epoch = state.sessionEpoch;
    try {
      const payload = await request('list', { query: { cursor } });
      if (epoch !== state.sessionEpoch) return;
      state.threads = mergeRows(quiet || cursor ? state.threads : [], Array.isArray(payload.threads) ? payload.threads : [], 'threadId');
      if (cursor) state.listExpanded = true;
      if (!quiet || !state.listExpanded) state.listCursor = payload.nextCursor || '';
      state.preferences = payload.preferences || {};
      renderList();
      setMessageStatus('');
      const partnerStart = $('[data-messages-partner-start]');
      const hasPartnerThread = initialPartner && state.threads.some((item) => item.partnerSlug === initialPartner && item.contextType === 'inquiry');
      partnerStart.hidden = !initialPartner || hasPartnerThread;
      if (!quiet && !state.selected) {
        const target = initialOrderId
          ? state.threads.find((item) => String(item.orderId) === initialOrderId)
          : state.threads.find((item) => item.threadId === new URL(location.href).searchParams.get('thread'));
        const requestedId = new URL(location.href).searchParams.get('thread');
        if (!target && (requestedId || initialOrderId)) { await openThread({ threadId: requestedId || ('order_' + initialOrderId), orderId: initialOrderId }); return; }
        const desktopDefault = !target && matchMedia('(min-width: 900px)').matches ? sortThreads(state.threads)[0] : null;
        if (target || desktopDefault) await openThread(target || desktopDefault);
      }
    } catch (error) {
      if (epoch !== state.sessionEpoch) return;
      if (error?.status === 401) return clearPrivateState();
      if (!quiet) list.innerHTML = '<div class="florame-messages__empty"><strong>Messaggi non disponibili</strong><p>Riprova tra poco. Le tue conversazioni restano salvate.</p><button type="button" class="florame-messages__save" data-messages-retry>Riprova</button></div>';
      setMessageStatus('Non siamo riusciti ad aggiornare i messaggi.');
      $('[data-messages-retry]')?.addEventListener('click', () => loadInbox());
      return false;
    } finally { state.inboxLoading = false; }
  }

  async function startPartnerConversation() {
    if (!initialPartner || state.busy) return;
    state.busy = true;
    const button = $('[data-messages-partner-start-button]');
    button.disabled = true;
    button.textContent = 'Apro…';
    try {
      const payload = await request('start', { method: 'POST', body: { partnerSlug: initialPartner } });
      if (payload.thread) {
        state.threads = [payload.thread, ...state.threads.filter((item) => item.threadId !== payload.thread.threadId)];
        $('[data-messages-partner-start]').hidden = true;
        renderList();
        await openThread(payload.thread);
      }
    } catch (error) {
      if (error?.status === 401) requestAuthentication(button, 'messages_start_partner');
      else setMessageStatus('Non riusciamo ad aprire la conversazione con questo fiorista.');
    }
    finally { state.busy = false; button.disabled = false; button.textContent = 'Scrivi'; }
  }

  async function sendMessage(event) {
    event.preventDefault();
    const text = draft.value.trim(), id = state.selected?.threadId;
    if (!text || !id || state.authExpired || !state.threadReady || state.selected.readOnly || state.selected.conversationKind === 'florame') return;
    state.outbox.push({ key: crypto.randomUUID(), threadId: id, text, status: 'queued', createdAt: new Date().toISOString() });
    state.drafts.delete(id); draft.value = ''; updateComposer(); saveSession();
    renderMessages(); void drainOutbox(id);
  }

  const utilitySheets = [];
  function utilitySheet(name, title) {
    const layer = document.createElement('div'); layer.className = 'florame-messages__sheet'; layer.hidden = true; layer.dataset.messagesUtility = name;
    layer.innerHTML = '<button type="button" class="florame-messages__sheet-backdrop" data-messages-utility-close aria-label="Chiudi" tabindex="-1"></button><section class="florame-messages__sheet-panel" role="dialog" aria-modal="true" aria-labelledby="fm-' + name + '-title" tabindex="-1"><header><h2 id="fm-' + name + '-title">' + title + '</h2><button type="button" data-messages-utility-close aria-label="Chiudi">×</button></header><div data-utility-content></div></section>';
    layer.querySelectorAll('[data-messages-utility-close]').forEach(button=>button.addEventListener('click',()=>closeUtility(layer)));
    root.appendChild(layer); utilitySheets.push(layer); return layer;
  }
  const supportSheet = utilitySheet('support','Assistenza florame.ai');
  const confirmSheet = utilitySheet('confirm','Prima di continuare');
  const problemSheet=utilitySheet('order-problem','Segnala un problema');
  function openOrderProblem() {
    if(!state.threadReady||state.authExpired||!state.selected?.orderId||demoMode)return;
    const selected={...state.selected},key=crypto.randomUUID(),content=$('[data-utility-content]',problemSheet);
    const categories=[['delay','⏰','Consegna in ritardo'],['not_received','📦','Ordine non ricevuto'],['wrong_bouquet','💐','Bouquet diverso'],['damaged','🥀','Fiori danneggiati'],['missing_extra','✉️','Biglietto o extra mancante'],['other','💬','Altro problema']];
    content.innerHTML='<form data-problem-form><p class="florame-messages__sheet-intro"><strong>'+escapeHtml(selected.orderNumber?'Ordine '+selected.orderNumber:'Il tuo ordine')+'</strong></p><fieldset class="florame-messages__problem-categories"><legend>Cosa è successo?</legend>'+categories.map(([value,emoji,label])=>'<label><input type="radio" name="category" value="'+value+'" required><span aria-hidden="true">'+emoji+'</span><strong>'+escapeHtml(label)+'</strong></label>').join('')+'</fieldset><label class="florame-messages__problem-detail">Descrivi il problema<textarea name="detail" rows="4" minlength="5" maxlength="1600" required placeholder="Raccontaci cosa è successo e cosa ti serve"></textarea></label><p role="alert" data-problem-error hidden></p><button type="submit" class="florame-messages__save">Invia segnalazione</button></form>';
    let busy=false;
    $('[data-problem-form]',content).addEventListener('submit',async event=>{
      event.preventDefault();if(busy)return;const form=event.currentTarget,values=new FormData(form),category=values.get('category'),text=String(values.get('detail')||'').trim();if(!category||text.length<5)return;
      busy=true;form.querySelectorAll('input,textarea,button').forEach(el=>el.disabled=true);const error=$('[data-problem-error]',content);error.hidden=true;
      try{await request('report_problem',{method:'POST',body:{threadId:selected.threadId,category,text,idempotencyKey:key}});content.innerHTML='<div class="florame-messages__empty" role="status"><strong>✅ Segnalazione ricevuta</strong><p>Il team florame.ai vede il problema e la conversazione di questo ordine.</p><button type="button" class="florame-messages__save" data-problem-done>Torna alla chat</button></div>';$('[data-problem-done]',content).onclick=()=>closeUtility(problemSheet);}
      catch(e){error.textContent=e.status===401?'Accedi di nuovo per inviare la segnalazione.':e.message||'Invio non riuscito. Riprova.';error.hidden=false;form.querySelectorAll('input,textarea,button').forEach(el=>el.disabled=false);}
      finally{busy=false;}
    });showUtility(problemSheet);
  }
  let confirmResult = null, supportEpoch = 0, supportOpening = false, cancelSupportWait = null;
  function showUtility(layer) {
    rememberSheetOpener(layer); layer.hidden = false;
    document.body.classList.add('florame-messages-overlay-open'); document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(()=>layer.querySelector('.florame-messages__sheet-panel').focus());
  }
  function closeUtility(layer, accepted = false, restoreFocus = true) {
    layer.hidden = true;
    if (restoreFocus) restoreSheetOpener(layer); else sheetOpeners.delete(layer);
    if(layer === confirmSheet && confirmResult) { const resolve=confirmResult; confirmResult=null; resolve(accepted); }
    if(layer === supportSheet) cancelSupportOpening();
    if([...utilitySheets,photoSheet,orderSheet,detailsSheet,settings].every(sheet=>!sheet || sheet.hidden)) {
      document.body.classList.remove('florame-messages-overlay-open'); document.documentElement.style.removeProperty('overflow');
    }
  }
  function confirmChoice(copy, label) {
    if(confirmResult) return Promise.resolve(false);
    $('[data-utility-content]',confirmSheet).innerHTML = '<p class="florame-messages__sheet-intro">' + escapeHtml(copy) + '</p><div class="florame-messages__utility-actions"><button type="button" data-choice-no>Torna alla chat</button><button type="button" class="florame-messages__save" data-choice-yes>' + escapeHtml(label) + '</button></div>';
    $('[data-choice-no]',confirmSheet).onclick=()=>closeUtility(confirmSheet);
    $('[data-choice-yes]',confirmSheet).onclick=()=>closeUtility(confirmSheet,true);
    showUtility(confirmSheet); return new Promise(resolve=>confirmResult=resolve);
  }
  function cancelSupportOpening() {
    supportEpoch++;
    cancelSupportWait?.(); cancelSupportWait = null;
    if (supportOpening) window.FlorameShopifyInbox?.close?.();
    supportOpening = false;
  }
  function supportContext(event) {
    // The inbox card is general help, even when desktop has selected a thread.
    const fromThread = event?.target?.closest?.('[data-messages-thread]');
    const selected = fromThread && state.threadReady && !state.authExpired ? state.selected : null;
    const proposalNode = event?.target?.closest?.('[data-proposal-id]');
    const proposalId = proposalNode?.dataset.proposalId;
    const proposal = selected && proposalId ? state.messages.find(row=>row.proposal?.proposalId === proposalId)?.proposal : null;
    const proposalExpired = proposal?.expiresAt && Date.parse(proposal.expiresAt) <= Date.now() && ['available','sent','viewed','checkout_started'].includes(proposal.status);
    const status = proposal ? (proposalExpired ? 'expired' : proposal.status) : selected?.requestStatus;
    const proposalCopy = {
      expired: ['Proposta scaduta', 'Questa proposta non è più utilizzabile. Puoi chiedere al fiorista una nuova proposta o contattare Florame.'],
      declined: ['Proposta non accettata', 'Puoi tornare alla conversazione per valutare un’altra proposta con il fiorista. Per altri dubbi, siamo qui.'],
      superseded: ['C’è una proposta più recente', 'Torna alla conversazione e cerca l’ultima proposta del fiorista. Se non la trovi, contattaci.'],
      unavailable: ['Proposta non disponibile', 'Chiedi al fiorista un’alternativa oppure contatta Florame per assistenza.'],
      accepted: ['Proposta confermata', 'Per chiarimenti sul pagamento, modifiche o problemi con la consegna, contatta Florame.']
    };
    const requestCopy = {
      awaiting_partner: ['In attesa del fiorista', 'La richiesta attende una risposta. Puoi controllarne i dettagli o chiedere aiuto a Florame.'],
      awaiting_manual_florist: ['Ricerca del fiorista in corso', 'Florame sta cercando un fiorista per la richiesta. Qui puoi chiedere un aggiornamento.'],
      declined: ['Richiesta non accettata', 'Consulta lo stato dell’ordine per gli aggiornamenti su annullamento o rimborso. Florame può aiutarti a chiarire i prossimi passi.'],
      expired: ['Richiesta scaduta', 'Consulta lo stato dell’ordine per gli aggiornamenti su annullamento o rimborso. Per dubbi, contatta Florame.'],
      counter_proposed: ['Nuova proposta del fiorista', 'Puoi rivedere la proposta nella conversazione. Contatta Florame se hai dubbi su come procedere.'],
      proposal_declined: ['Proposta non accettata', 'Per valutare come proseguire con la richiesta, contatta Florame.'],
      proposal_expired: ['Proposta scaduta', 'Per valutare come proseguire con la richiesta, contatta Florame.']
    };
    let copy = proposal ? proposalCopy[status] : requestCopy[status];
    if (status === 'payment_failed') copy = ['Pagamento da verificare', 'Se vedi un addebito o non sai se l’ordine è confermato, contattaci prima di ripetere il pagamento.'];
    if (status === 'payment_processing') copy = ['Pagamento in verifica', 'Controlla lo stato dell’ordine prima di ripetere il pagamento. Per chiarimenti, contatta Florame.'];
    const stateTitle = copy?.[0] || '';
    const isFlorame = selected?.conversationKind === 'florame';
    const hasOrder = selected && (selected.orderId || selected.orderNumber);
    if (!copy) copy = hasOrder ? ['Aiuto con il tuo ordine', 'Per pagamenti, modifiche, consegne o rimborsi, scrivi al team Florame.']
      : selected?.readOnly && !isFlorame ? ['Conversazione in sola lettura', 'Qui non puoi rispondere. Per ricevere aiuto, apri la chat di assistenza Florame.']
      : selected && !isFlorame ? ['Fiorista o assistenza?', 'Per fiori e composizione puoi scrivere al fiorista. Per acquisti o problemi con il sito, contatta Florame.']
      : ['', 'Per ordini, pagamenti, consegne o aiuto con il sito, scrivi al team Florame.'];
    const fields = selected && !isFlorame ? [
      selected.orderNumber ? 'Ordine: ' + selected.orderNumber : selected.orderId ? 'Riferimento ordine: ' + selected.orderId : '',
      selected.partnerName ? 'Fiorista: ' + selected.partnerName : '',
      proposal?.title ? 'Bouquet: ' + proposal.title : '',
      proposal?.proposalId ? 'Proposta: ' + proposal.proposalId : '',
      stateTitle ? 'Stato: ' + stateTitle : ''
    ].filter(Boolean) : [];
    return {title:copy[0], description:copy[1], summary:fields.join('\n'), canReply:!!(selected && !isFlorame && !selected.readOnly), canViewOrder:!!selected?.orderDetail};
  }
  function openSupport(event) {
    if (demoMode) { event?.preventDefault?.(); return demo.note(); }
    event?.preventDefault?.();
    if (!supportSheet.hidden) return;
    const context = supportContext(event), summary = context.summary;
    const trigger = event?.target?.closest?.('button') || document.activeElement;
    const shared = window.FlorameAccountCenter?.openUtility?.('help', {
      trigger,
      helpContext: summary ? {
        ...context,
        returnLabel: context.canViewOrder ? 'Vedi dettagli dell’ordine' : 'Torna alla chat del fiorista',
        onReturn: context.canViewOrder || context.canReply ? () => { if (!state.authExpired) { if (context.canViewOrder) openOrderDetails(); else draft?.focus(); } } : null
      } : null
    });
    if (shared) return;
    // Keep support reachable if the shared menu runtime is unavailable.
    const content = $('[data-utility-content]',supportSheet);
    const icon = path => '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"></path></svg>';
    const chatIcon = icon('M20 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z M8 9h8 M8 13h5');
    const chevron = icon('m9 5 7 7-7 7');
    $('header [data-messages-utility-close]',supportSheet).innerHTML=icon('m6 6 12 12 M18 6 6 18');
    const email = 'mailto:assistenza@florame.ai?subject=' + encodeURIComponent('Assistenza Florame') + (summary ? '&body=' + encodeURIComponent('Buongiorno, ho bisogno di aiuto con:\n\n' + summary + '\n\nLa mia domanda: ') : '');
    content.innerHTML = '<div class="florame-messages__support-context">' + (context.title ? '<strong>' + escapeHtml(context.title) + '</strong>' : '') + '<p>' + escapeHtml(context.description) + '</p></div>'
      + '<button type="button" class="florame-messages__save florame-messages__support-chat" data-support-open>' + chatIcon + '<span>Apri chat Florame</span></button>'
      + '<p class="florame-messages__support-note">Si apre una chat dedicata con l’assistenza, separata dai messaggi al fiorista.</p><p role="status" aria-live="polite" data-support-status></p>'
      + (context.canViewOrder || context.canReply ? '<button type="button" class="florame-messages__support-return" data-support-return>' + (context.canViewOrder ? 'Vedi dettagli dell’ordine' : 'Torna alla chat del fiorista') + '</button>' : '')
      + (summary ? '<details class="florame-messages__support-summary"><summary><span>Dettagli utili da condividere</span>' + chevron + '</summary><p class="florame-messages__support-note">La chat di assistenza non riceve automaticamente questi dettagli. Puoi copiarli e incollarli; nell’email sono già preparati.</p><textarea readonly aria-label="Dettagli da condividere con l’assistenza">' + escapeHtml(summary) + '</textarea><button type="button" data-support-copy>Copia dettagli</button></details>' : '')
      + '<details class="florame-messages__support-contacts"><summary><span>Preferisci email o telefono?</span>' + chevron + '</summary><div class="florame-messages__support-fallback" data-support-fallback><a href="' + escapeHtml(email) + '">' + icon('M3 5h18v14H3z M3 5l9 7 9-7') + '<span><strong>Scrivi un’email</strong><small>assistenza@florame.ai</small></span></a><a href="tel:+393931389130">' + icon('M5 3h4l2 5-3 2a14 14 0 0 0 6 6l2-3 5 2v4a2 2 0 0 1-2 2C10 21 3 14 3 5a2 2 0 0 1 2-2') + '<span><strong>Chiama Florame</strong><small>+39 393 138 9130</small></span></a></div></details>';
    const button = $('[data-support-open]',content), buttonLabel = $('span',button), statusNode = $('[data-support-status]',content);
    const contacts = $('.florame-messages__support-contacts',content);
    const unavailable = message => {
      statusNode.textContent=message;
      const details=$('.florame-messages__support-summary',content);
      if(details) details.open=false;
      contacts.open=true; buttonLabel.textContent='Riprova ad aprire la chat';
    };
    $('[data-support-return]',content)?.addEventListener('click',()=> { closeUtility(supportSheet); if(context.canViewOrder) openOrderDetails(); });
    $('[data-support-copy]',content)?.addEventListener('click',async ()=> {
      const input = $('textarea',content);
      try { await navigator.clipboard.writeText(summary); statusNode.textContent='Dettagli copiati. Incollali nella chat di assistenza.'; }
      catch { input.closest('details').open=true; input.focus(); input.select(); statusNode.textContent='Copia non disponibile: seleziona e copia i dettagli qui sopra.'; }
    });
    contacts.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=> {
      if(supportOpening) { cancelSupportOpening(); button.disabled=false; button.removeAttribute('aria-busy'); buttonLabel.textContent='Apri chat Florame'; }
      statusNode.textContent=link.protocol==='mailto:' ? 'Si apre la tua app email. Il messaggio sarà inviato solo quando lo invierai tu.' : 'Si apre l’app per telefonare.';
    }));
    button.onclick = async event => {
      if(supportOpening) return;
      if(!navigator.onLine) { unavailable('Sei offline. Riconnettiti per la chat oppure usa il numero di telefono.'); return; }
      const epoch=++supportEpoch; supportOpening=true; button.disabled=true; button.setAttribute('aria-busy','true'); buttonLabel.textContent='Apertura chat…';
      statusNode.textContent='Puoi restare qui oppure scegliere email o telefono.';
      let timer;
      try {
        const opener=window.FlorameShopifyInbox?.open || window.openShopifyInboxFromMenu;
        const limit = new Promise(resolve=>{ timer=setTimeout(()=>resolve(false),15000); cancelSupportWait=()=>resolve(false); });
        const opened=typeof opener === 'function' && await Promise.race([Promise.resolve(opener(event)),limit]);
        if(epoch !== supportEpoch) return;
        if(opened === true) { supportOpening=false; closeUtility(supportSheet,false,false); }
        else { window.FlorameShopifyInbox?.close?.(); unavailable('La chat non si è aperta. Riprova oppure scegli email o telefono qui sotto.'); }
      } catch (_) {
        if(epoch===supportEpoch) { window.FlorameShopifyInbox?.close?.(); unavailable('Non riusciamo ad aprire la chat. Riprova oppure scegli email o telefono.'); }
      } finally { clearTimeout(timer); if(epoch===supportEpoch) { cancelSupportWait=null; supportOpening=false; button.disabled=false; button.removeAttribute('aria-busy'); } }
    };
    if(!navigator.onLine) unavailable('Sei offline. Riconnettiti per la chat oppure usa il numero di telefono.');
    showUtility(supportSheet);
  }

  function renderPreferences() {
    const rows = [
      ['partnerOffers', 'Offerte dai tuoi fioristi', 'Promozioni pertinenti, senza riempire la posta.'],
      ['backInStock', 'Di nuovo disponibile', 'Quando torna un bouquet o un fiore salvato.'],
      ['seasonalIdeas', 'Idee e tutorial', 'Spunti utili per occasioni e stagioni.'],
      ['reorderReminders', 'Promemoria ricorrenze', 'Un avviso discreto prima delle date importanti.']
    ];
    $('[data-messages-preferences]').innerHTML = rows.map(([key, title, copy]) => `<label class="florame-messages__preference"><span><strong>${escapeHtml(title)}</strong><small>${escapeHtml(copy)}</small></span><input type="checkbox" data-preference="${key}" ${state.preferences[key] === true ? 'checked' : ''}></label>`).join('');
  }

  // Each sheet returns to its opener and keeps keyboard navigation inside its panel.
  const sheetOpeners = new WeakMap();
  function rememberSheetOpener(sheet, opener = document.activeElement) {
    if (sheet.hidden) sheetOpeners.set(sheet, opener);
  }
  function restoreSheetOpener(sheet) {
    const opener = sheetOpeners.get(sheet);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    sheetOpeners.delete(sheet);
  }
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || event.defaultPrevented) return;
    const activeSheet = [...utilitySheets, photoSheet, orderSheet, detailsSheet, settings].find(sheet => sheet && !sheet.hidden);
    const panel = activeSheet?.querySelector('.florame-messages__sheet-panel');
    if (!panel) return;
    const controls = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')]
      .filter(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); panel.focus(); return; }
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel || !panel.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });

  function openSettings() {
    renderPreferences();
    rememberSheetOpener(settings);
    settings.hidden = false;
    document.body.classList.add('florame-messages-overlay-open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => $('.florame-messages__sheet-panel', settings)?.focus());
  }

  function closeSettings() {
    settings.hidden = true;
    restoreSheetOpener(settings);
    if (detailsSheet.hidden) document.body.classList.remove('florame-messages-overlay-open');
    document.documentElement.style.removeProperty('overflow');
  }

  async function saveSettings() {
    const preferences = { ...state.preferences };
    $$('[data-preference]', settings).forEach((input) => { preferences[input.dataset.preference] = input.checked; });
    const button = $('[data-messages-settings-save]');
    button.disabled = true;
    button.textContent = 'Salvo…';
    try {
      const payload = await request('preferences', { method: 'POST', body: { preferences } });
      state.preferences = payload.preferences || preferences;
      closeSettings();
      setMessageStatus('Preferenze salvate.');
      setTimeout(() => { if (status.textContent === 'Preferenze salvate.') setMessageStatus(''); }, 2200);
    } catch (_) { button.textContent = 'Riprova'; }
    finally { button.disabled = false; if (button.textContent !== 'Riprova') button.textContent = 'Salva preferenze'; }
  }

  $('[data-messages-search-toggle]').addEventListener('click', (event) => {
    const search = $('[data-messages-search]');
    search.hidden = false;
    event.currentTarget.setAttribute('aria-expanded', 'true');
    $('[data-messages-search-input]').focus();
  });
  $('[data-messages-search-close]').addEventListener('click', () => {
    $('[data-messages-search]').hidden = true;
    $('[data-messages-search-toggle]').setAttribute('aria-expanded', 'false');
    state.search = '';
    $('[data-messages-search-input]').value = '';
    renderList();
  });
  $('[data-messages-search-input]').addEventListener('input', (event) => { state.search = event.target.value.trim(); renderList(); });
  root.addEventListener('click', event=> { if(event.target.closest('[data-messages-support], [data-proposal-support]')) openSupport(event); });
  messagesNode.addEventListener('click', (event) => {
    const retry = event.target.closest('[data-message-retry]');
    if(retry) { void retryMessage(retry.dataset.messageRetry); return; }
    const edit = event.target.closest('[data-message-edit]');
    if(edit) {
      const row = state.outbox.find(row=>row.key === edit.dataset.messageEdit);
      if(row) {
        if(row.status === 'uncertain') { setMessageStatus('Verifica prima l’invio: il messaggio potrebbe essere già arrivato.'); return; }
        if(draft.value.trim()) { setMessageStatus('Conserva o invia la bozza attuale prima di modificare questo messaggio.'); return; }
        state.outbox = state.outbox.filter(item=>item !== row); draft.value = row.text; state.drafts.set(row.threadId,row.text); saveSession(); updateComposer(); refreshLocalThread(row.threadId); draft.focus(); void drainOutbox(row.threadId);
      }
      return;
    }
    const proposalAction = event.target.closest('[data-proposal-action]');
    if (proposalAction) {
      const proposalId = proposalAction.closest('[data-proposal-id]')?.dataset.proposalId;
      if (proposalAction.dataset.proposalAction === 'checkout') checkoutProposal(proposalAction, proposalId);
      else declineProposal(proposalAction, proposalId);
      return;
    }
    const action = event.target.closest('[data-message-event-action]');
    if (!action) return;
    const name = action.dataset.messageEventAction;
    if (name === 'view_order') openOrderDetails();
    if (name === 'support') openSupport(event);
  });
  $('[data-messages-partner-start-button]').addEventListener('click', startPartnerConversation);
  $('[data-messages-back]').addEventListener('click', closeThread);
  $('[data-messages-details]').addEventListener('click', openPartnerDetails);
  $$('[data-messages-details-close]').forEach((button) => button.addEventListener('click', closePartnerDetails));
  $$('[data-messages-order-close]').forEach((button) => button.addEventListener('click', () => closeOrderDetails()));
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-messages-photo]');
    if (button) openPhoto(button);
  });
  $$('[data-messages-photo-close]').forEach(button => button.addEventListener('click', closePhoto));
  $('[data-messages-photo-image]')?.addEventListener('error', event => {
    event.currentTarget.hidden = true;
    $('[data-messages-photo-error]').hidden = false;
  });
  $('[data-messages-order-message]')?.addEventListener('click', () => {
    closeOrderDetails();
    draft?.focus();
  });
  composer.addEventListener('submit', sendMessage);
  draft.addEventListener('input', () => { if (state.selected) state.drafts.set(state.selected.threadId, draft.value); saveSession(); updateComposer(); });
  scrollNode.addEventListener('scroll', updateLatest, { passive: true });
  latest?.addEventListener('click', jumpToLatest);
  const viewport = window.visualViewport;
  let viewportFrame;
  const updateViewport = () => {
    cancelAnimationFrame(viewportFrame);
    viewportFrame = requestAnimationFrame(() => {
      const height = viewport?.height || innerHeight;
      const keyboard = height < innerHeight - 140;
      root.style.setProperty('--messages-viewport-height', `${height}px`);
      root.style.setProperty('--messages-viewport-top', `${viewport?.offsetTop || 0}px`);
      root.classList.toggle('is-keyboard-open', keyboard);
      const nav = document.querySelector('.florame-global-nav');
      if (nav) {
        // The dock can expand, disappear or change height. Reserve its actual
        // layout box, not a second set of hard-coded navigation dimensions.
        const reserve = nav.getClientRects().length ? nav.offsetHeight : 0;
        root.style.setProperty('--messages-nav-height', `${reserve}px`);
      }
      updateLatest();
    });
  };
  viewport?.addEventListener('resize', updateViewport);
  viewport?.addEventListener('scroll', updateViewport);
  window.addEventListener('resize', updateViewport);
  if (window.ResizeObserver) {
    let draftWidth = 0;
    let previousScrollHeight = scrollNode.clientHeight;
    const layoutObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (entry.target === scrollNode) {
          const wasAtEnd = previousScrollHeight > 0 && scrollNode.scrollHeight - scrollNode.scrollTop - previousScrollHeight < 40;
          previousScrollHeight = scrollNode.clientHeight;
          requestAnimationFrame(() => {
            if (wasAtEnd && state.threadReady) scrollNode.scrollTo({ top: scrollNode.scrollHeight, behavior: 'instant' });
            updateLatest();
          });
        } else if (entry.target === composer) {
          if (entry.contentRect.width !== draftWidth) {
            draftWidth = entry.contentRect.width;
            requestAnimationFrame(resizeComposer);
          }
        } else updateViewport();
      }
    });
    layoutObserver.observe(composer);
    layoutObserver.observe(scrollNode);
    const observeNavigation = () => {
      const nav = document.querySelector('.florame-global-nav');
      if (nav) layoutObserver.observe(nav);
      updateViewport();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeNavigation, { once: true });
    else observeNavigation();
  }
  updateViewport();
  $$('[data-messages-filter]').forEach(button => button.addEventListener('click', () => {
    state.filter = button.dataset.messagesFilter;
    $$('[data-messages-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    renderList();
  }));
  $('[data-messages-settings-open]').addEventListener('click', (event) => {
    if (!initialAuthenticated) return requestAuthentication(event.currentTarget, 'messages_preferences');
    openSettings();
  });
  $$('[data-messages-settings-close]').forEach((button) => button.addEventListener('click', closeSettings));
  $('[data-messages-settings-save]').addEventListener('click', saveSettings);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const utility = utilitySheets.find(sheet=>!sheet.hidden);
    if (utility) closeUtility(utility);
    else if (photoSheet && !photoSheet.hidden) closePhoto();
    else if (orderSheet && !orderSheet.hidden) closeOrderDetails();
    else if (!detailsSheet.hidden) closePartnerDetails();
    else if (!settings.hidden) closeSettings();
    else if (root.classList.contains('is-thread-open') && matchMedia('(max-width: 899px)').matches) closeThread();
  });
  document.addEventListener('visibilitychange', () => {
    if (initialAuthenticated && !state.authExpired && !document.hidden) refreshVisible();
  });

  function refreshVisible() {
    if (!initialAuthenticated || state.authExpired) return;
    if (document.hidden || !navigator.onLine || state.pageBusy || state.proposalBusy || state.threadLoading || state.inboxLoading) return false;
    return Promise.all([state.selected ? openThread(state.selected, { quiet: true }) : null, loadInbox({ quiet: true })]);
  }
  window.addEventListener('online', () => { refreshVisible(); new Set(state.outbox.filter(row=>row.status==='queued').map(row=>row.threadId)).forEach(id=>void drainOutbox(id)); });
  window.addEventListener('offline', () => { setMessageStatus('Sei offline. I messaggi e le bozze restano qui.'); if(state.selected) refreshLocalThread(state.selected.threadId); });
  window.addEventListener('florame:native-language-change', () => {
    // Reformat the current conversation without refetching or changing its draft.
    renderList();
    if (state.selected) {
      renderThreadHeader(state.selected);
      renderContext(state.selected);
      if (state.threadReady) renderMessages({ keepScroll: true });
    }
    window.FlorameI18n?.apply(root);
  });
  if (initialAuthenticated) loadInbox();
  else loginState();
  function bindCustomerLive() {
    if (demoMode || customerLive || !initialAuthenticated || state.authExpired || !window.FlorameLiveSync) return;
    customerLive = window.FlorameLiveSync.customer({ getSession: () => request('live_session'), onChange: async () => {
      const result = await refreshVisible();
      if (result === false) return false; // Busy: retry locally, without a DB read.
      if (result?.includes(false)) throw new Error('MESSAGES_REFRESH_FAILED');
    } });
  }
  window.addEventListener('florame:live-sync-ready', bindCustomerLive);
  bindCustomerLive();
  const stopCustomerLive = () => { customerLive?.close(); customerLive = null; };
  window.addEventListener('pagehide', stopCustomerLive);
  window.addEventListener('pageshow', event => { if (event.persisted) bindCustomerLive(); });
  ['florame:logout', 'florame:auth-changed'].forEach(name => window.addEventListener(name, stopCustomerLive));
  state.poll = setInterval(() => {
    if (customerLive) return;
    if (!initialAuthenticated || state.authExpired || !navigator.onLine || document.hidden || state.busy || state.proposalBusy || state.threadLoading || state.pageBusy) return;
    if (state.selected) openThread(state.selected, { quiet: true });
    else loadInbox({ quiet: true });
  }, 10 * 60000);
})();
